(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSlider extends HTMLElement {
    // Resolved on use rather than captured. `this.slides` is the one exception:
    // the clones below are built here, so the list is this element's own record
    // of what it created - it is rebuilt whenever setup runs.
    get track() { return this.querySelector('[data-slider-track]'); }

    connectedCallback() {
      // The window listener and the autoplay timer are torn down on disconnect,
      // so they are re-established on every connect. Held as a bound reference
      // so disconnectedCallback can actually remove it - an anonymous listener
      // on window outlives the element it closes over.
      this.onResize = this.onResize || (() => this.jumpTo(this.getCenterIndex(), false));
      window.addEventListener('resize', this.onResize);

      // The rest of setup runs once: it CLONES slides into the track, and
      // connectedCallback also fires on a plain move, so doing it twice would
      // leave duplicates behind.
      if (this._bound) {
        this.startAutoplay();
        return;
      }
      const track = this.track;
      if (!track) return;
      this._bound = true;

      const realSlides = Array.from(track.querySelectorAll('[data-real-slide]'));
      if (realSlides.length < 2) return;

      const firstClone = realSlides[0].cloneNode(true);
      const lastClone = realSlides[realSlides.length - 1].cloneNode(true);
      [firstClone, lastClone].forEach((clone) => {
        clone.removeAttribute('data-real-slide');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      });

      const leadingSentinel = track.firstElementChild;
      const trailingSentinel = track.lastElementChild;
      track.insertBefore(lastClone, leadingSentinel.nextSibling);
      track.insertBefore(firstClone, trailingSentinel);

      this.slides = Array.from(track.querySelectorAll('[data-slideshow-slide]'));
      this.lastIndex = this.slides.length - 1;
      this.firstRealIndex = 1;
      this.lastRealIndex = this.lastIndex - 1;

      this.jumpTo(this.firstRealIndex, false);

      // Delegated so the arrows keep working if the controls are re-rendered.
      ThemeBind.delegate(this, 'click', 'button[name="previous"]', () => this.advance(-1));
      ThemeBind.delegate(this, 'click', 'button[name="next"]', () => this.advance(1));

      let scrollEndTimer;
      // `scroll` does not bubble - delegate it in the capture phase.
      ThemeBind.delegate(this, 'scroll', '[data-slider-track]', () => {
        if (this.suppressScrollEnd) return;
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => this.handleScrollEnd(), 120);
      }, { capture: true, passive: true });

      this.addEventListener('mouseenter', () => clearInterval(this.autoplayInterval));
      this.addEventListener('mouseleave', () => this.startAutoplay());

      this.startAutoplay();
    }

    startAutoplay() {
      // `slides` is only set once the clones are in place; without it there is
      // nothing to advance through.
      if (this.dataset.autoplay !== 'true' || !this.slides) return;
      clearInterval(this.autoplayInterval);
      const speed = (parseFloat(this.dataset.speed) || 5) * 1000;
      this.autoplayInterval = setInterval(() => this.advance(1), speed);
    }

    disconnectedCallback() {
      // Without this the removed bar kept a resize listener and an autoplay
      // timer running against a track that is no longer on the page.
      window.removeEventListener('resize', this.onResize);
      clearInterval(this.autoplayInterval);
    }

    centerOffset(slide) {
      const track = this.track;
      return slide.offsetLeft + slide.clientWidth / 2 - (track ? track.clientWidth : 0) / 2;
    }

    getCenterIndex() {
      const track = this.track;
      if (!track || !this.slides) return this.firstRealIndex;
      const center = track.scrollLeft + track.clientWidth / 2;
      let closest = this.firstRealIndex;
      let minDist = Infinity;
      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - center);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    jumpTo(idx, smooth = true) {
      const track = this.track;
      const slide = this.slides && this.slides[idx];
      if (!track || !slide) return;
      const target = this.centerOffset(slide);
      if (smooth) {
        track.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        this.suppressScrollEnd = true;
        const prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = prev;
        requestAnimationFrame(() => {
          this.suppressScrollEnd = false;
        });
      }
    }

    advance(dir) {
      const idx = this.getCenterIndex();
      this.jumpTo(idx + dir, true);
    }

    handleScrollEnd() {
      const idx = this.getCenterIndex();
      if (idx === 0) {
        this.jumpTo(this.lastRealIndex, false);
      } else if (idx === this.lastIndex) {
        this.jumpTo(this.firstRealIndex, false);
      }
    }
  }

  if (!customElements.get('announcement-bar-slider')) {
    customElements.define('announcement-bar-slider', AnnouncementBarSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-categories"] && !Shopify.designMode) return;
  try {
    
  class CollectionCategories extends HTMLElement {
    // Resolved on use: the description block is measured a frame later, and a
    // swap can land in between.
    get details() { return this.querySelector('[data-collection-description]'); }

    connectedCallback() {
      this._measure();
      // Re-measure when the description is re-rendered - whether it needs the
      // expand toggle at all depends on the text that is actually in it.
      ThemeBind.onSwap(this, () => this._measure());
    }

    _measure() {
      requestAnimationFrame(() => {
        const details = this.details;
        if (!details) return;
        const summary = details.querySelector('summary');
        if (!summary) return;
        const clamp = summary.querySelector('span p') || summary.querySelector('span');
        if (!clamp) return;
        if (clamp.scrollHeight <= clamp.clientHeight + 1) {
          details.removeAttribute('open');
          details.classList.add('pointer-events-none');
          const toggle = summary.querySelector('span:last-child');
          if (toggle) toggle.classList.add('hidden');
          summary.style.cursor = 'default';
        }
      });
    }
  }
  customElements.define('collection-categories', CollectionCategories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filter-cards"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilterCards extends HTMLElement {
    // Resolved on use - the card rail is re-rendered by filtering, and the whole
    // block is a candidate for a test variant.
    get dropdown() { return this.querySelector('[data-dropdown]'); }
    get panel() { return this.querySelector('[data-dropdown-panel]'); }
    get toggle() { return this.querySelector('[data-dropdown-toggle]'); }
    get scroller() { return this.querySelector('[data-scroller]'); }
    get prevBtn() { return this.querySelector('[data-slider-prev]'); }
    get nextBtn() { return this.querySelector('[data-slider-next]'); }

    connectedCallback() {
      // Bound once. These listeners live on `this` (or on window/document with
      // teardown below), and connectedCallback also fires on a plain move.
      if (!this._bound) {
        this._bound = true;

        // Selecting a card applies (or removes) the matching Shopify facet by
        // navigating to the URL Liquid pre-built from the filter value - the same
        // thing the native filter form does. No hidden-input mirroring. Delegated,
        // so re-rendered cards keep working without re-binding.
        ThemeBind.delegate(this, 'change', '[data-filter-card] input[type="checkbox"]', function (e) {
          const card = this.closest('[data-filter-card]');
          const url = card && card.dataset.nav;
          if (!url) return;
          e.preventDefault();
          window.location.href = url;
        });

        // Mobile dropdown open/close.
        ThemeBind.delegate(this, 'click', '[data-dropdown-toggle]', function () {
          const panel = this.closest('collection-filter-cards').querySelector('[data-dropdown-panel]');
          if (!panel) return;
          const open = panel.classList.toggle('hidden');
          this.setAttribute('aria-expanded', String(!open));
          this.querySelector('svg')?.classList.toggle('rotate-180', !open);
        });

        // Desktop slider pagination.
        ThemeBind.delegate(this, 'click', '[data-slider-prev]', () => this.scroll(-1));
        ThemeBind.delegate(this, 'click', '[data-slider-next]', () => this.scroll(1));
        // `scroll` does not bubble - delegate it in the capture phase.
        ThemeBind.delegate(this, 'scroll', '[data-scroller]', () => this.updateButtons(), {
          capture: true,
          passive: true,
        });
      }

      // Outside-click and resize go on shared targets, so they are held as bound
      // references and removed on disconnect. Registering them inside
      // connectedCallback without teardown left one live copy per re-render,
      // each still holding the elements it was created against.
      this.onDocumentClick = (e) => {
        const dropdown = this.dropdown;
        const panel = this.panel;
        if (!dropdown || !panel) return;
        if (dropdown.contains(e.target) || panel.classList.contains('hidden')) return;
        panel.classList.add('hidden');
        const toggle = this.toggle;
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.querySelector('svg')?.classList.remove('rotate-180');
        }
      };
      this.onResize = () => this.updateButtons();
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('resize', this.onResize);

      this.updateButtons();
      // Re-measure when the rail's contents change - the arrows' disabled state
      // and the whole control's visibility depend on the scroll width.
      ThemeBind.onSwap(this, () => this.updateButtons());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('resize', this.onResize);
    }

    scroll(direction) {
      const scroller = this.scroller;
      if (!scroller) return;
      const card = scroller.querySelector('[data-filter-card]');
      const inner = scroller.firstElementChild;
      const gap = (inner && parseFloat(getComputedStyle(inner).columnGap)) || 16;
      const step = card ? card.getBoundingClientRect().width + gap : scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    updateButtons() {
      const scroller = this.scroller;
      if (!scroller) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      const buttons = this.querySelector('[data-slider-buttons]');
      // Hide the controls entirely when everything fits (inline style overrides
      // the lg:flex class cleanly; '' restores class-driven display).
      if (buttons) buttons.style.display = max <= 1 ? 'none' : '';
      const prev = this.prevBtn;
      const next = this.nextBtn;
      if (prev) prev.disabled = scroller.scrollLeft <= 1;
      if (next) next.disabled = scroller.scrollLeft >= max - 1;
    }
  }
  customElements.define('collection-filter-cards', CollectionFilterCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-drawer"] && !Shopify.designMode) return;
  try {
    
  // Registered once for the page and resolved on use throughout. The bar is
  // driven entirely by localStorage plus triggers that live in product cards
  // all over the site, so it has to keep working when either end is replaced:
  // the listeners below are all delegated on document, and every element -
  // including the bar itself - is looked up at the moment it is needed.
  (function setupCompareDrawer() {
    const root = () => document.querySelector('compare-drawer');
    const inRoot = (sel) => document.querySelector('compare-drawer ' + sel);
    const panel = () => inRoot('[data-compare-panel]');
    const grid = () => inRoot('[data-compare-grid]');
    const countEl = () => inRoot('[data-compare-count]');
    const collapseBtn = () => inRoot('[data-compare-collapse]');
    const chevron = () => inRoot('[data-compare-chevron]');
    const clearCloseBtn = () => inRoot('[data-compare-clear-close]');
    const bodyEl = () => inRoot('[data-compare-body]');

    // Parsed lazily and memoised per script element: a replacement bar brings
    // its own <script type="application/json"> config with it.
    let configCache = null;
    let configFrom = null;
    const config = () => {
      const el = inRoot('[data-compare-config]');
      if (!el) return { rows: [], icons: {} };
      if (configFrom !== el) {
        configFrom = el;
        try { configCache = JSON.parse(el.textContent); } catch (e) { configCache = { rows: [], icons: {} }; }
      }
      return configCache;
    };

    const max = () => {
      const el = root();
      return (el && parseInt(el.dataset.max, 10)) || 4;
    };
    const STORE_KEY = 'kukoon:compare';
    const COLLAPSE_KEY = 'kukoon:compare:collapsed';
    const fetchCache = {};

    const checkSvg =
      '<svg viewBox="0 0 19 19" width="17" height="17" class="shrink-0" aria-hidden="true">' +
      '<path d="M15.142,9.983,10.875,14.25,9.42,12.8M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Z" transform="translate(-2.5 -2.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></svg>';
    const closeSvg =
      '<svg viewBox="0 0 18 17" width="11" height="11" fill="none" aria-hidden="true">' +
      '<path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>';
    const plusSvg =
      '<svg viewBox="0 0 10 10" width="16" height="16" fill="none" aria-hidden="true">' +
      '<path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';

    /* ---- store ---- */
    // Stored items carry a formatted `price` string (e.g. "£129.00") captured at the
    // time they were added. Those are stale the moment the shopper switches market,
    // so the stored currency is stamped and mismatched entries are dropped rather
    // than replayed as GBP prices inside a EUR market.
    const CURRENCY_KEY = STORE_KEY + ':currency';
    const activeCurrency = () =>
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

    const read = () => {
      try {
        const stored = localStorage.getItem(CURRENCY_KEY);
        const current = activeCurrency();
        if (stored && current && stored !== current) {
          localStorage.removeItem(STORE_KEY);
          localStorage.setItem(CURRENCY_KEY, current);
          return [];
        }
        return JSON.parse(localStorage.getItem(STORE_KEY)) || [];
      } catch (e) { return []; }
    };
    const write = (items) => {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(items));
        const current = activeCurrency();
        if (current) localStorage.setItem(CURRENCY_KEY, current);
      } catch (e) {}
    };

    /* ---- visibility ---- */
    let hideTimer = null;
    const show = () => {
      const el = root();
      if (!el) return;
      window.clearTimeout(hideTimer);
      el.classList.remove('hidden');
      requestAnimationFrame(() => {
        const p = panel();
        if (p) p.dataset.active = '';
      });
    };
    const hide = () => {
      const p = panel();
      if (p) delete p.dataset.active;
      hideTimer = window.setTimeout(() => {
        // Re-resolve: the bar may have been replaced during the transition.
        const el = root();
        if (el) el.classList.add('hidden');
      }, 300);
    };

    /* ---- collapse ---- */
    const applyCollapsed = (collapsed) => {
      const button = collapseBtn();
      const arrow = chevron();
      const clearClose = clearCloseBtn();
      const body = bodyEl();
      if (button) button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      if (collapsed) {
        if (arrow) arrow.dataset.collapsed = '';
        if (clearClose) clearClose.dataset.collapsed = '';
        if (body) body.style.maxHeight = '0px';
      } else {
        if (arrow) delete arrow.dataset.collapsed;
        if (clearClose) delete clearClose.dataset.collapsed;
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }
    };
    const isCollapsed = () => localStorage.getItem(COLLAPSE_KEY) === '1';
    ThemeBind.on('click', '[data-compare-collapse]', () => {
      const next = !isCollapsed();
      localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0');
      applyCollapsed(next);
    });

    /* ---- product data (lazy) ---- */
    // Market-prefixed: the unprefixed /products/<handle>.js returns the DEFAULT
    // market's prices, so an EUR shopper was comparing GBP amounts labelled "€".
    const rootUrl = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
    const getProduct = (handle) => {
      if (fetchCache[handle]) return fetchCache[handle];
      fetchCache[handle] = fetch(rootUrl + '/products/' + handle + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
      return fetchCache[handle];
    };

    const optionValues = (product, name) => {
      if (!product || !product.options) return '';
      const idx = product.options.findIndex(
        (o) => (o.name || o) === name
      );
      if (idx < 0) return '';
      const key = 'option' + (idx + 1);
      const seen = [];
      (product.variants || []).forEach((v) => {
        if (v[key] && seen.indexOf(v[key]) === -1) seen.push(v[key]);
      });
      return seen.join(', ');
    };

    // Price row: custom.compare_function_price_metric is a 1-based variant index
    // (stashed on the trigger) - 4 → the 4th variant's price, 3 → the 3rd, etc.
    // Falls back to the 4th variant, else first available (else first variant),
    // else the stashed money string before the product.js fetch resolves.
    const comparePrice = (item, product) => {
      const variants = (product && product.variants) || [];
      const idx = parseInt(item.meta && item.meta.priceMetric, 10);
      if (!isNaN(idx) && variants[idx - 1]) return formatMoney(variants[idx - 1].price);
      const variant = variants[3] || variants.find((v) => v.available) || variants[0];
      if (variant) return formatMoney(variant.price);
      return item.price || '';
    };

    const rowValue = (row, item, product) => {
      switch (row.source) {
        case 'price': return comparePrice(item, product);
        case 'material': return item.meta ? item.meta.material : '';
        case 'type': return product ? product.type : '';
        case 'vendor': return product ? product.vendor : '';
        case 'availability': return product ? (product.available ? 'In stock' : 'Out of stock') : '';
        case 'tags': return product && product.tags ? product.tags.join(', ') : '';
        case 'option': return optionValues(product, row.option || '');
        default: return '';
      }
    };

    /* ---- metafield-backed tier rows (thickness / weight) ----
       Values ride on the trigger button (data-compare-thickness / -weight)
       and are stashed in item.meta - product.js never returns metafields. The
       stored value is "{number}{unit}" (e.g. "12mm" / "6.5kg"), so the unit is
       stripped before bucketing into a 3-bar tier:
         thickness (realmedia.pile_height, mm): SLIM <10 · BALANCED 10–24.99 · PLUSH 25+
         weight    (custom.rug_weight, kg):     Light <5 · Medium 5–7.99 · Heavy 8+
       Rendered as a 3-bar graph + caption (thickness shows "Name" + number;
       weight shows "Name - Xkg"). */
    const TIER_CONFIG = {
      thickness: { labels: ['SLIM', 'BALANCED', 'PLUSH'], unit: 'mm', tier: (n) => (n < 10 ? 1 : n < 25 ? 2 : 3) },
      weight: { labels: ['Light', 'Medium', 'Heavy'], unit: 'kg', tier: (n) => (n < 5 ? 1 : n < 8 ? 2 : 3) }
    };
    const tierInfo = (raw, kind) => {
      const cfg = TIER_CONFIG[kind];
      if (!cfg || raw == null || raw === '') return null;
      const n = parseFloat(String(raw).trim());
      if (isNaN(n)) return null;
      const tier = cfg.tier(n);
      // parseFloat already drops a trailing ".0" (12.0 → 12) while keeping 12.5.
      return { tier: tier, label: cfg.labels[tier - 1], number: String(n), unit: cfg.unit };
    };
    // Thickness and weight share one layout: bars with the number to their
    // right, and the (uppercase) tier name below them.
    const tierGraph = (info) => {
      const bars = [7, 11, 15].map((h, i) => {
        const cls = i < info.tier ? 'fill-(--color-accent)' : 'fill-(--color-fg)/15';
        return '<rect x="' + (i * 8) + '" y="' + (15 - h) + '" width="5.5" height="' + h + '" rx="1.2" class="' + cls + '"/>';
      }).join('');
      const svg = '<svg viewBox="0 0 21.5 15" width="24" height="17" aria-hidden="true">' + bars + '</svg>';
      const capCls = 'font-sans text-[11px] font-normal leading-3 tracking-[-0.02em]';
      return '<span class="inline-flex flex-col items-center gap-1">' +
        '<span class="inline-flex items-center gap-1.5">' + svg +
          '<span class="' + capCls + ' text-(--color-muted)">' + escapeHtml(info.number + info.unit) + '</span>' +
        '</span>' +
        '<span class="' + capCls + ' uppercase text-(--color-fg)">' + escapeHtml(info.label) + '</span>' +
        '</span>';
    };

    /* Case-insensitive check for a realmedia.product_features label on an item. */
    const hasFeature = (item, label) => {
      if (!label || !item.meta || !item.meta.features) return false;
      const want = String(label).trim().toLowerCase();
      return item.meta.features.split('|').some((f) => f.trim().toLowerCase() === want);
    };

    /* full HTML for a value cell, or '' when there is nothing to show */
    const rowCellHtml = (row, item, product) => {
      if (row.source === 'thickness' || row.source === 'weight') {
        const info = tierInfo(item.meta ? item.meta[row.source] : '', row.source);
        return info ? tierGraph(info) : '';
      }
      const icons = config().icons || {};
      const iconSpan = (svg, label) =>
        '<span class="inline-flex h-6 w-6 shrink-0 items-center justify-center text-(--color-fg) [&>svg]:h-full [&>svg]:w-auto [&>svg]:fill-current" aria-label="' + escapeHtml(label) + '">' + svg + '</span>';
      // Machine Washable: washing icon when the "Machine Washable" feature is set.
      if (row.source === 'machine_washable') {
        return hasFeature(item, 'Machine Washable') && icons.washing ? iconSpan(icons.washing, 'Machine washable') : '';
      }
      // Spill Resistant: a tick when the "Liquid Repellent" feature is set.
      if (row.source === 'spill_resistant') {
        return hasFeature(item, 'Liquid Repellent') ? '<span class="text-(--color-accent)">' + checkSvg + '</span>' : '';
      }
      // Pet & Child Friendly: baby + paw icons - only when BOTH washable and repellent are set.
      if (row.source === 'pet_child_friendly') {
        return hasFeature(item, 'Machine Washable') && hasFeature(item, 'Liquid Repellent')
          ? (icons.baby ? iconSpan(icons.baby, 'Child friendly') : '') + (icons.paw ? iconSpan(icons.paw, 'Pet friendly') : '')
          : '';
      }
      // Easy Clean: an icon per matching feature (no tick). '' → dash when none match.
      if (row.source === 'easy_clean') {
        return [
          ['machine washable', icons.washing],
          ['liquid repellent', icons.baby],
          ['pet friendly', icons.paw]
        ]
          .filter((pair) => pair[1] && hasFeature(item, pair[0]))
          .map((pair) => iconSpan(pair[1], pair[0]))
          .join('');
      }
      // Feature check: a tick when the configured feature label is present.
      if (row.source === 'feature_check') {
        return hasFeature(item, row.match) ? '<span class="text-(--color-accent)">' + checkSvg + '</span>' : '';
      }
      // Delivery: custom.pdp_boxed → "Boxed" when 1/true, otherwise "Rolled".
      if (row.source === 'boxed') {
        const b = String((item.meta && item.meta.boxed) || '').trim().toLowerCase();
        return '<span>' + (b === '1' || b === 'true' ? 'Boxed' : 'Rolled') + '</span>';
      }
      const val = rowValue(row, item, product);
      if (!val) return '';
      return (row.check ? '<span class="text-(--color-accent)">' + checkSvg + '</span>' : '') +
        '<span>' + escapeHtml(val) + '</span>';
    };

    // Currency comes from the active market; the locale comes from the storefront,
    // not the browser - otherwise a UK shopper with a French browser saw "129,99 £".
    // No 'USD' fallback: defaulting to dollars in a GBP/EUR store is never right.
    const formatMoney = (cents) => {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      const locale = document.documentElement.lang || undefined;
      if (!currency) return '';
      try { return (cents / 100).toLocaleString(locale, { style: 'currency', currency }); }
      catch (e) { return ''; }
    };

    /* ---- render ---- */
    const render = () => {
      const gridEl = grid();
      if (!gridEl) return;
      const cfg = config();
      const MAX = max();
      const items = read().slice(0, MAX);
      const count = countEl();
      if (count) count.textContent = items.length + ' ' + cfg.selectedSingular;
      gridEl.innerHTML = '';

      const slots = [];
      for (let i = 0; i < MAX; i++) slots.push(items[i] || null);

      const cell = (cls, html) => {
        const d = document.createElement('div');
        d.className = cls;
        if (html != null) d.innerHTML = html;
        return d;
      };

      /* header row: label cell (holds "Clear all" when populated) + product/empty cells */
      gridEl.appendChild(cell(
        'flex items-end border-b-[3px] border-b-(--color-border) pb-4',
        items.length
          ? '<button type="button" data-compare-clear class="inline-flex cursor-pointer items-center font-sans text-[14px] leading-4.5 tracking-[-0.03em] text-(--color-muted) underline transition hover:text-(--color-fg) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--color-accent) lg:text-[16px] lg:leading-5">' + escapeHtml(cfg.clearLabel) + '</button>'
          : null
      ));
      slots.forEach((item) => {
        if (item) {
          const c = cell('relative flex flex-col items-center gap-2 border-b-[3px] border-b-(--color-border) px-3 pb-4 pt-3 text-center');
          c.innerHTML =
            '<button type="button" class="absolute right-1 top-1 inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-full text-(--color-muted) transition hover:text-(--color-fg)" aria-label="Remove" data-compare-remove="' + item.handle + '">' + closeSvg + '</button>' +
            '<a href="' + item.url + '" class="block aspect-[5/6] w-full max-w-[120px] overflow-hidden bg-(--color-surface)">' +
            (item.image ? '<img src="' + item.image + '" alt="" loading="lazy" class="h-full w-full object-cover">' : '') +
            '</a>' +
            '<a href="' + item.url + '" class="line-clamp-2 font-sans text-[14px] font-normal leading-4.5 tracking-[-0.03em] text-(--color-fg) no-underline hover:underline lg:text-[16px] lg:leading-5.5">' + escapeHtml(item.title) + '</a>';
          gridEl.appendChild(c);
        } else {
          const c = cell('flex items-center justify-center border-b-[3px] border-b-(--color-border) px-3 py-6');
          c.innerHTML =
            '<button type="button" data-compare-add class="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-(--color-fg)/25 text-(--color-fg)/50 transition hover:border-(--color-fg)/50 hover:text-(--color-fg) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--color-accent)" aria-label="' + escapeHtml(cfg.emptyLabel) + '">' + plusSvg + '</button>';
          gridEl.appendChild(c);
        }
      });

      /* spec rows */
      cfg.rows.forEach((row) => {
        /* optional sub-label under the row header, e.g. the reference size a
           price or weight is quoted at ("160cm x 230cm") */
        const labelHtml = row.sublabel
          ? '<span class="flex flex-col gap-0.5">' +
              '<span>' + escapeHtml(row.label) + '</span>' +
              '<span class="font-sans text-[11px] font-normal leading-3 tracking-[-0.02em] text-(--color-muted)">' + escapeHtml(row.sublabel) + '</span>' +
            '</span>'
          : escapeHtml(row.label);
        gridEl.appendChild(
          cell('flex min-h-12.5 items-center border-b border-(--color-fg)/10 py-1.5 pr-3 font-sans text-[14px] font-medium leading-4.5 tracking-[-0.03em] text-(--color-fg) lg:text-[16px] lg:leading-5', labelHtml)
        );
        slots.forEach((item, i) => {
          const c = cell('flex min-h-12.5 items-center gap-2 border-b border-(--color-fg)/10 py-1.5 px-3 font-sans text-[14px] font-medium leading-4.5 tracking-[-0.03em] text-(--color-fg) lg:text-[16px] lg:leading-5');
          if (item) {
            c.dataset.compareValue = item.handle + '|' + i;
            c.dataset.compareRow = cfg.rows.indexOf(row);
            c.innerHTML = '<span class="text-(--color-muted)">' + cfg.loadingLabel + '</span>';
          }
          gridEl.appendChild(c);
        });
      });

      /* buy row */
      gridEl.appendChild(cell('py-4'));
      slots.forEach((item) => {
        const c = cell('px-2 py-4');
        if (item) {
          c.innerHTML =
            '<a href="' + item.url + '" class="inline-flex h-11 w-full items-center justify-center rounded-full bg-(--color-accent) px-4 text-button font-mono uppercase text-(--color-accent-fg) no-underline transition hover:opacity-90">' + escapeHtml(cfg.buyLabel) + '</a>';
        }
        gridEl.appendChild(c);
      });

      /* fill spec cells once product data resolves */
      items.forEach((item, i) => {
        getProduct(item.handle).then((product) => {
          cfg.rows.forEach((row, ri) => {
            const c = gridEl.querySelector('[data-compare-value="' + item.handle + '|' + i + '"][data-compare-row="' + ri + '"]');
            if (!c) return;
            c.innerHTML = rowCellHtml(row, item, product) || '<span class="text-(--color-muted)">&mdash;</span>';
          });
          // Re-resolved: the fetch resolves long after render(), by which point
          // the bar may have been replaced.
          const body = bodyEl();
          if (body && !isCollapsed()) body.style.maxHeight = body.scrollHeight + 'px';
        });
      });

      if (!isCollapsed()) requestAnimationFrame(() => {
        const body = bodyEl();
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      });
    };

    const escapeHtml = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ));

    /* sync the active state of every compare trigger on the page */
    const syncTriggers = () => {
      const handles = read().map((i) => i.handle);
      document.querySelectorAll('[data-compare-toggle]').forEach((btn) => {
        const active = handles.indexOf(btn.dataset.compareHandle) !== -1;
        if (active) btn.dataset.compareActive = '';
        else delete btn.dataset.compareActive;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    /* briefly pulse every compare toggle on the page to point the shopper at
       where products get added (fired by the empty-slot "+") */
    const flashTriggers = () => {
      const btns = document.querySelectorAll('[data-compare-toggle]');
      btns.forEach((btn) => {
        btn.classList.remove('compare-flash');
        void btn.offsetWidth; /* restart the animation if already running */
        btn.classList.add('compare-flash');
      });
      window.setTimeout(() => {
        document.querySelectorAll('.compare-flash').forEach((b) => b.classList.remove('compare-flash'));
      }, 1600);
    };

    /* Swipe/drag guard. Compare toggles are rendered once per slide over the
       PDP's native touch-scroll gallery, so a swipe can end as a synthetic
       click on a toggle and add the product. Track pointer travel between down
       and up and suppress clicks that are really the tail of a swipe/drag. */
    const DRAG_THRESHOLD = 10; // px
    let downX = 0, downY = 0, wasDrag = false;
    document.addEventListener('pointerdown', (e) => {
      downX = e.clientX; downY = e.clientY; wasDrag = false;
    }, true);
    document.addEventListener('pointerup', (e) => {
      wasDrag = Math.abs(e.clientX - downX) > DRAG_THRESHOLD ||
                Math.abs(e.clientY - downY) > DRAG_THRESHOLD;
    }, true);

    /* ---- events ---- */
    const toggle = (btn) => {
      const handle = btn.dataset.compareHandle;
      if (!handle) return;
      let items = read();
      const idx = items.findIndex((i) => i.handle === handle);
      if (idx !== -1) {
        items.splice(idx, 1);
      } else {
        if (items.length >= max()) items = items.slice(1); /* drop oldest to make room */
        items.push({
          handle: handle,
          title: btn.dataset.compareTitle || handle,
          image: btn.dataset.compareImage || '',
          url: btn.dataset.compareUrl || (rootUrl + '/products/' + handle),
          price: btn.dataset.comparePrice || '',
          meta: {
            thickness: btn.dataset.compareThickness || '',
            weight: btn.dataset.compareWeight || '',
            features: btn.dataset.compareFeatures || '',
            boxed: btn.dataset.compareBoxed || '',
            priceMetric: btn.dataset.comparePriceMetric || '',
            material: btn.dataset.compareMaterial || ''
          }
        });
      }
      write(items);
      syncTriggers();
      render();
      if (items.length > 0) { show(); applyCollapsed(isCollapsed()); }
      else hide();
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-compare-toggle]');
      if (trigger) { e.preventDefault(); if (wasDrag) return; toggle(trigger); return; }
      const add = e.target.closest('[data-compare-add]');
      if (add) { e.preventDefault(); hide(); flashTriggers(); return; }
      const clear = e.target.closest('[data-compare-clear]');
      if (clear) {
        e.preventDefault();
        write([]);
        syncTriggers();
        render();
        hide();
        return;
      }
      const remove = e.target.closest('[data-compare-remove]');
      if (remove) {
        const handle = remove.getAttribute('data-compare-remove');
        write(read().filter((i) => i.handle !== handle));
        syncTriggers();
        render();
        if (read().length === 0) hide();
        return;
      }
    });

    /* collapse the bar when clicking anywhere outside it - but ignore clicks on
       a compare toggle (those live outside the panel and add/remove products,
       which should keep the bar expanded) */
    document.addEventListener('click', (e) => {
      const el = root();
      if (!el || el.classList.contains('hidden') || isCollapsed()) return;
      if (e.target.closest('[data-compare-panel]')) return;
      if (e.target.closest('[data-compare-toggle]')) return;
      localStorage.setItem(COLLAPSE_KEY, '1');
      applyCollapsed(true);
    });

    /* hide the bar while the cart drawer is open so it can't cover the
       checkout button; the attribute is independent of the bar's own
       hidden state, so it returns to normal once the cart closes */
    document.addEventListener('cart-drawer:open', () => {
      const el = root();
      if (el) el.dataset.cartOpen = '';
    });
    document.addEventListener('cart-drawer:close', () => {
      const el = root();
      if (el) delete el.dataset.cartOpen;
    });

    /* ---- init ----
       Driven by ready() rather than run inline, so a bar that arrives later -
       a deferred section, or a swapped-in one - is populated and shown from
       the stored selection exactly as the original would have been. */
    ThemeBind.ready('compare-drawer', () => {
      render();
      syncTriggers();
      if (read().length > 0) {
        show();
        applyCollapsed(isCollapsed());
      }
    });

    /* repaint trigger active-state when compare buttons appear after load -
       search results and deferred sections cloned into the DOM on scroll
       */
    if (window.MutationObserver && document.body) {
      let scheduled = false;
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; syncTriggers(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewSlider extends HTMLElement {
    // Resolved on use: renderCards() replaces the scroller's contents, and the
    // whole card rail can be re-rendered by a test variant.
    get scroller() { return this.querySelector('[data-scroller]'); }

    connectedCallback() {
      // Arrows are delegated on this element, so they survive the rail being
      // re-rendered - and bound once, because the listener outlives a move.
      if (!this._bound) {
        this._bound = true;
        ThemeBind.delegate(this, 'click', '[data-slider-prev]', () => this.scroll(-1));
        ThemeBind.delegate(this, 'click', '[data-slider-next]', () => this.scroll(1));
      }

      // "See all reviews" opens the <reviews-drawer> (the Reviews.io Polaris widget);
      // that element listens for [data-reviews-see-all] clicks via document delegation.

      // Live Reviews.io data (opt-in via data-reviewsio-store on this element):
      // per-product (needs a SKU) or store-wide (scope="store", no SKU required).
      if (this.dataset.reviewsioStore && (this.dataset.reviewsioSku || this.dataset.reviewsioScope === 'store')) this.loadReviewsio();
    }

    scroll(direction) {
      const scroller = this.scroller;
      if (!scroller) return;
      const card = scroller.querySelector('article');
      const gap = parseFloat(getComputedStyle(scroller).columnGap) || 16;
      const step = card ? card.offsetWidth + gap : scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    // ----- Reviews.io -----
    async loadReviewsio() {
      const store = this.dataset.reviewsioStore;
      const sku = this.dataset.reviewsioSku;
      const scope = this.dataset.reviewsioScope || 'product';
      const max = parseInt(this.dataset.reviewsioMax, 10) || 12;
      const minRating = parseInt(this.dataset.reviewsioMinRating, 10) || 0;
      // Public reads need no API key. Store-wide uses /product/reviews/all - a flat
      // catalogue-wide product-review feed that honours minRating + sort. Product mode
      // uses the per-SKU endpoints. Response shapes differ, so parsing is defensive.
      let urls;
      if (scope === 'store') {
        let base = `https://api.reviews.io/product/reviews/all?store=${encodeURIComponent(store)}&per_page=${max}&sort=highest_rating`;
        if (minRating) base += `&minRating=${minRating}`;
        urls = [base];
      } else {
        // Per-SKU: /product/review is the confirmed keyless endpoint (tried first);
        // /reviews?sku is a secondary fallback that 401s on some accounts.
        urls = [
          `https://api.reviews.io/product/review?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(sku)}&per_page=${max}`,
          `https://api.reviews.io/reviews?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(sku)}&type=product_review&per_page=${max}`,
        ];
      }
      let data = null;
      for (const url of urls) {
        try {
          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!res.ok) continue;
          const json = await res.json();
          if (this.extractReviews(json).length) { data = json; break; }
          if (!data) data = json; // keep for a possible stats-only summary
        } catch (e) { /* try next */ }
      }
      if (!data) return; // leave manual fallback in place

      // Client-side rating floor as a safety net - the endpoint's minRating isn't
      // guaranteed to be honoured across the different response shapes.
      let reviews = this.extractReviews(data);
      if (minRating) {
        reviews = reviews.filter((r) => (this.num(this.pick(r, ['rating', 'review_rating', 'score', 'stars'])) || 0) >= minRating);
      }
      reviews = reviews.slice(0, max);

      if (reviews.length) this.renderCards(reviews);
      // In store-wide mode the visible cards are a filtered (e.g. 5★) slice, so a live
      // average/total would misrepresent the catalogue - keep the merchant's manual
      // summary. Product mode still reflects that product's real stats.
      if (scope !== 'store') this.renderSummary(data, reviews.length);
    }

    pick(obj, keys) {
      if (!obj) return undefined;
      for (const k of keys) if (obj[k] != null && obj[k] !== '') return obj[k];
      return undefined;
    }

    num(v) { const n = parseFloat(v); return isNaN(n) ? null : n; }

    extractReviews(data) {
      if (!data) return [];
      let list = data.reviews;
      if (list && !Array.isArray(list) && Array.isArray(list.data)) list = list.data;
      if (!Array.isArray(list)) list = Array.isArray(data) ? data : [];
      return list;
    }

    renderSummary(data, shownCount) {
      const statsObj = data.stats || data.rating || data;
      const avg = this.num(this.pick(statsObj, ['average_rating', 'average', 'rating', 'overall_rating', 'score']));
      const total = this.num(this.pick(statsObj, ['total_reviews', 'total', 'count', 'num_ratings', 'review_count'])) || shownCount;

      const numEl = this.querySelector('[data-reviewsio-rating-number]');
      if (numEl && avg != null) numEl.textContent = avg.toFixed(1);

      const starsEl = this.querySelector('[data-reviewsio-stars]');
      if (starsEl && avg != null) {
        starsEl.innerHTML = this.starsHtml(avg, 29, '27.58', 'text-(--color-muted)');
        starsEl.setAttribute('aria-label', `${avg.toFixed(1)} out of 5 stars`);
      }

      const countEl = this.querySelector('[data-reviewsio-count]');
      if (countEl && total != null) {
        const suffix = this.dataset.reviewsioCountSuffix || 'reviews';
        countEl.textContent = `${total.toLocaleString()} ${suffix}`;
      }
    }

    starsHtml(rating, width, height, colorClass) {
      const filled = Math.round(rating);
      let out = '';
      for (let i = 1; i <= 5; i++) {
        const dim = i <= filled ? '' : ' opacity-30';
        out +=
          `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 13.622 12.955" class="${colorClass}${dim}" aria-hidden="true">` +
          '<path d="M6.811,0,5.2,4.949H0L4.21,8.007,2.6,12.955,6.811,9.9l4.21,3.058L9.413,8.007l4.209-3.058h-5.2Z" fill="currentColor"/></svg>';
      }
      return out;
    }

    // Reviews.io returns HTML-encoded text (e.g. &quot;, &amp;, &#39;) - and
    // sometimes DOUBLE-encoded (&amp;quot;). Decode repeatedly until stable so no
    // entity survives; otherwise a single pass leaves "&quot;" which esc() then
    // re-encodes to "&amp;quot;" and renders as the literal text "&quot;".
    decodeEntities(s) {
      if (s == null) return '';
      const t = document.createElement('textarea');
      let str = String(s);
      for (let i = 0; i < 5; i++) {
        t.innerHTML = str;
        const decoded = t.value;
        if (decoded === str) break;
        str = decoded;
      }
      return str;
    }

    esc(s) {
      const d = document.createElement('div');
      d.textContent = this.decodeEntities(s);
      return d.innerHTML;
    }

    reviewerName(r) {
      const direct = this.pick(r, ['author', 'reviewer_name', 'name']);
      if (direct) return direct;
      const reviewer = r.reviewer || r.customer || {};
      if (typeof reviewer === 'object') {
        const parts = [this.pick(reviewer, ['first_name', 'firstname']), this.pick(reviewer, ['last_name', 'lastname'])].filter(Boolean);
        if (parts.length) return parts.join(' ');
        const n = this.pick(reviewer, ['name', 'display_name']);
        if (n) return n;
      }
      return '';
    }

    renderCards(reviews) {
      const scroller = this.scroller;
      if (!scroller) return;
      // Verified-buyer tick badge (theme icon-tick.svg) in place of an avatar.
      const tickSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-tick h-full w-full" viewBox="0 0 20 20">' +
        '<path fill="#108043" stroke="#fff" d="m16.136 6.979.003-.004a1.499 1.499 0 0 0-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 1 0 3.94 12.06l2.999 3c.289.29.675.44 1.1.439h.019a1.5 1.5 0 0 0 1.08-.522z"/></svg>';
      const avatarHtml =
        '<span class="flex h-7 w-7 shrink-0 items-center justify-center" aria-hidden="true">' + tickSvg + '</span>';
      const cards = reviews.map((r, i) => {
        const last = i === reviews.length - 1;
        const rating = this.num(this.pick(r, ['rating', 'review_rating', 'score', 'stars'])) || 0;
        const title = this.esc(this.pick(r, ['title', 'heading', 'review_title']) || '');
        const body = this.esc(this.pick(r, ['review', 'comments', 'content', 'body', 'text', 'description']) || '');
        const name = this.esc(this.reviewerName(r));

        const nameHtml = name
          ? `<span class="font-sans text-xs leading-4 tracking-[-0.03em] text-(--color-fg)">${name}</span>`
          : '';
        const titleHtml = title
          ? `<h3 class="m-0 font-sans text-base font-semibold leading-5 tracking-[-0.03em] text-(--color-fg)">${title}</h3>`
          : '';
        const bodyHtml = body
          ? `<p class="m-0 line-clamp-8 font-sans text-sm leading-[18px] tracking-[-0.03em] text-(--color-muted)">${body}</p>`
          : '';

        return (
          `<article class="flex h-[225px] w-[268px] shrink-0 flex-col gap-2 rounded-[10px] border border-(--color-fg)/10 bg-(--color-surface) p-3 pb-5 snap-center ${last ? 'lg:snap-end' : 'lg:snap-start'}">` +
          '<div class="flex items-center justify-between">' +
          `<div class="flex items-center gap-2">${avatarHtml}${nameHtml}</div>` +
          `<span class="flex items-center gap-px" aria-label="${rating} out of 5 stars">${this.starsHtml(rating, 11, '10.5', 'text-(--color-muted)')}</span>` +
          '</div>' +
          titleHtml +
          bodyHtml +
          '</article>'
        );
      });
      scroller.innerHTML = cards.join('');
    }
  }
  customElements.define('review-slider', ReviewSlider);

  // Slide-in drawer hosting the full Reviews.io Polaris widget. Opened by any
  // [data-reviews-see-all] trigger (See-all links in the slider). The widget is
  // heavy, so it is only initialised the first time the drawer opens: the config
  // is stashed on window.__kukoonReviewsWidgetConfig by the Liquid <script>, and
  // loadWidget() injects build.js then calls new ReviewsWidget() once.
  class ReviewsDrawer extends HTMLElement {
    // The widget rewrites the drawer's contents once it initialises, so nothing
    // inside is captured.
    get panel() { return this.querySelector('[data-reviews-drawer]'); }
    get overlay() { return this.querySelector('[data-reviews-drawer-overlay]'); }
    get mount() { return this.querySelector('[data-reviews-widget-mount]'); }

    connectedCallback() {
      this.closeTimer = this.closeTimer || null;
      this.lastFocus = this.lastFocus || null;

      // Triggers live inside the (possibly deferred) slider, so delegate on document.
      this.onSeeAll = (e) => {
        const trigger = e.target.closest && e.target.closest('[data-reviews-see-all]');
        if (!trigger) return;
        e.preventDefault();
        this.open(trigger);
      };
      document.addEventListener('click', this.onSeeAll);

      this.onKeydown = (e) => {
        const panel = this.panel;
        if (e.key === 'Escape' && panel && panel.dataset.active !== undefined) this.close();
      };
      document.addEventListener('keydown', this.onKeydown);

      // Close controls are delegated on this element so they keep working once
      // the Polaris widget has replaced the drawer's markup. Bound once: the
      // listener stays on the element across a disconnect/reconnect.
      if (this._bound) return;
      this._bound = true;
      ThemeBind.delegate(this, 'click', '[data-reviews-drawer-close]', () => this.close());
      ThemeBind.delegate(this, 'click', '[data-reviews-drawer-overlay]', () => this.close());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onSeeAll);
      document.removeEventListener('keydown', this.onKeydown);
    }

    open(trigger) {
      const panel = this.panel;
      if (!panel) return;
      this.lastFocus = trigger || document.activeElement;
      window.clearTimeout(this.closeTimer);
      this.loadWidget();
      panel.hidden = false;
      requestAnimationFrame(() => {
        panel.dataset.active = '';
        const overlay = this.overlay;
        if (overlay) overlay.dataset.active = '';
        panel.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      const panel = this.panel;
      if (!panel) return;
      delete panel.dataset.active;
      const overlay = this.overlay;
      if (overlay) delete overlay.dataset.active;
      document.documentElement.style.overflow = '';
      this.closeTimer = window.setTimeout(() => {
        // Re-resolve: the widget may have re-rendered the drawer meanwhile.
        const current = this.panel;
        if (current) current.hidden = true;
      }, 300);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        try { this.lastFocus.focus(); } catch (e) {}
      }
    }

    loadWidget() {
      if (this.widgetLoaded) return;
      const cfg = (window.__kukoonReviewsWidgetConfig || {})[this.dataset.configKey];
      const mount = this.mount;
      if (!mount || !mount.id || !cfg) return;
      this.widgetLoaded = true;
      const mountId = mount.id;
      const run = () => {
        try { new window.ReviewsWidget('#' + mountId, cfg); } catch (e) { /* noop */ }
      };
      if (window.ReviewsWidget) { run(); return; }
      // Reuse the build.js tag if another drawer already injected it.
      let script = document.querySelector('script[data-reviewsio-build]');
      if (script) { script.addEventListener('load', run); return; }
      script = document.createElement('script');
      script.src = 'https://widget.reviews.io/polaris/build.js';
      script.async = true;
      script.setAttribute('data-reviewsio-build', '');
      script.addEventListener('load', run);
      document.head.appendChild(script);
    }
  }
  customElements.define('reviews-drawer', ReviewsDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollections extends HTMLElement {
    // Resolved on use: the resize listener outlives any re-render of the rail.
    get scrollEl() { return this.querySelector('[data-fc-scroll]'); }

    connectedCallback() {
      this._center = this._center.bind(this);
      this._center();
      window.addEventListener('resize', this._center);
      // Re-centre when the rail's contents change - the offset depends on the
      // total scroll width, which a swapped-in set of cards changes.
      ThemeBind.onSwap(this, this._center);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._center);
    }

    _center() {
      if (window.matchMedia('(min-width: 1024px)').matches) return;
      const el = this.scrollEl;
      if (!el) return;
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 0) return;
      // Only re-centre when the rail's extent has actually changed. This also
      // runs from a mutation observer, and centring on every change would yank
      // the rail back under a shopper who had scrolled it.
      if (this._centeredFor === max) return;
      this._centeredFor = max;
      el.scrollLeft = max / 2;
    }
  }
  customElements.define('featured-collections', FeaturedCollections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    // Resolved on demand rather than captured in connectedCallback: the header
    // markup can be replaced under this element by an A/B swap, and a ref taken
    // at connect time would then be measuring and styling a detached node.
    get header() {
      return this.closest('.section-header') || document.querySelector('.section-header');
    }

    get predictiveSearch() {
      return this.querySelector('predictive-search');
    }

    connectedCallback() {
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Held as a bound reference so disconnectedCallback can actually remove
      // it. `.bind()` inline returns a new function every call, so the old
      // version left one live matchMedia listener behind per re-connection.
      this.onBreakpointChange = this.setHeaderHeight.bind(this);
      this.breakpoint = window.matchMedia('(max-width: 990px)');
      this.breakpoint.addEventListener('change', this.onBreakpointChange);

      if (this.headerIsAlwaysSticky && this.header) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // Read the height once here (on init + breakpoint change) and cache it, so the
      // per-scroll reveal()/reset() don't repeatedly read offsetHeight (forced reflow).
      const header = this.header;
      if (!header) return;
      this.headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      if (!header.classList.contains('shopify-section-header-hidden')) {
        document.documentElement.style.setProperty('--header-offset', `${this.headerHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.breakpoint) this.breakpoint.removeEventListener('change', this.onBreakpointChange);
      if (this.observer) this.observer.disconnect();
    }

    createObserver() {
      const header = this.header;
      if (!header) return;
      this.observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.observer.observe(header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const header = this.header;
      if (!header) return;

      const predictiveSearch = this.predictiveSearch;
      if (predictiveSearch && predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.style.setProperty('--header-offset', '0px');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.classList.add('header-animate');
      document.documentElement.style.setProperty('--header-offset', `${this.headerHeight}px`);
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.classList.remove('header-animate');
      document.documentElement.style.setProperty('--header-offset', `${this.headerHeight}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ----- Search overlay -----
  // The open triggers live all over the header (and, on some templates, in the
  // page body), so they are delegated on document; the overlay's own controls
  // are delegated on the overlay. Nothing is captured, so a header or search
  // block replaced by a test variant is wired the moment it lands.
  const searchOverlay = () => document.querySelector('[data-search-overlay]');
  let lastSearchFocus = null;

  const openSearchOverlay = (trigger) => {
    const overlay = searchOverlay();
    if (!overlay) return;
    if (!overlay.hidden && !overlay.classList.contains('hidden')) return;
    // Stashed on the element rather than in a closure so a re-created overlay
    // still restores focus to whatever opened it.
    lastSearchFocus = trigger || document.activeElement;
    const headerEl = document.querySelector('.section-header');
    if (headerEl) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(headerEl.getBoundingClientRect().bottom)}px`
      );
    }
    overlay.hidden = false;
    overlay.classList.remove('hidden');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      const inputs = overlay.querySelectorAll('input[type="search"][data-search-overlay-input]');
      const visibleInput = Array.from(inputs).find((i) => i.offsetParent !== null);
      (visibleInput || overlay.querySelector('[data-search-overlay-input]'))?.focus();
    });
  };

  const closeSearchOverlay = () => {
    const overlay = searchOverlay();
    if (!overlay) return;
    overlay.hidden = true;
    overlay.classList.add('hidden');
    document.documentElement.style.overflow = '';
    if (lastSearchFocus && typeof lastSearchFocus.focus === 'function') {
      try { lastSearchFocus.blur(); } catch (e) {}
    }
  };

  ThemeBind.on('click', '[data-search-overlay-open]', function (e) {
    e.preventDefault();
    if (this.tagName === 'INPUT') this.blur();
    openSearchOverlay(this);
  });
  // `focus` does not bubble; `focusin` is its delegatable equivalent.
  ThemeBind.on('focusin', 'input[data-search-overlay-open]', function (e) {
    e.preventDefault();
    this.blur();
    openSearchOverlay(this);
  });

  ThemeBind.on('click', '[data-search-overlay-close]', closeSearchOverlay);

  document.addEventListener('keydown', (e) => {
    const overlay = searchOverlay();
    if (e.key === 'Escape' && overlay && !overlay.hidden) closeSearchOverlay();
  });

  ThemeBind.on('click', '[data-search-overlay-tab]', function () {
    const overlay = searchOverlay();
    if (!overlay) return;
    const target = this.getAttribute('data-search-overlay-tab');
    overlay.querySelectorAll('[data-search-overlay-tab]').forEach((t) => {
      const active = t === this;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    overlay.querySelectorAll('[data-search-overlay-panel]').forEach((p) => {
      p.classList.toggle('hidden', p.getAttribute('data-search-overlay-panel') !== target);
    });
  });

  // ----- Localization slideout -----
  const localizationSlideout = () => document.querySelector('[data-localization-slideout]');
  let lastLocalizationFocus = null;
  let localizationCloseTimer = null;

  const openLocalization = (trigger) => {
    const slideout = localizationSlideout();
    if (!slideout) return;
    lastLocalizationFocus = trigger || document.activeElement;
    window.clearTimeout(localizationCloseTimer);
    slideout.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      slideout.dataset.state = 'open';
      const focusEl = slideout.querySelector('[data-localization-slideout-close]');
      focusEl && focusEl.focus();
    });
  };

  const closeLocalization = () => {
    const slideout = localizationSlideout();
    if (!slideout) return;
    slideout.dataset.state = 'closed';
    document.documentElement.style.overflow = '';
    localizationCloseTimer = window.setTimeout(() => {
      // Re-resolve: the slideout may have been replaced during the transition.
      const current = localizationSlideout();
      if (current) current.hidden = true;
    }, 300);
    if (lastLocalizationFocus && typeof lastLocalizationFocus.focus === 'function') {
      try { lastLocalizationFocus.focus(); } catch (e) {}
    }
  };

  ThemeBind.on('click', '[data-header-localization-trigger]', function (e) {
    e.preventDefault();
    openLocalization(this);
  });
  ThemeBind.on('click', '[data-localization-slideout-close]', closeLocalization);
  ThemeBind.on('click', '[data-localization-slideout-overlay]', closeLocalization);
  document.addEventListener('keydown', (e) => {
    const slideout = localizationSlideout();
    if (e.key === 'Escape' && slideout && !slideout.hidden) closeLocalization();
  });

  // ----- Mega-nav panels: inflate the <template> on first hover/focus -----
  // Registered through ready() so a nav replaced by a test variant still gets
  // its panels inflated; the `once` listeners die with the element they were on.
  ThemeBind.ready('[data-mega-nav-panel]', (panel) => {
    const trigger = panel.closest('li');
    if (!trigger) return;
    const activate = () => {
      const template = panel.querySelector('[data-mega-nav-template]');
      if (!template) return;
      panel.appendChild(template.content.cloneNode(true));
      template.remove();
    };
    trigger.addEventListener('mouseenter', activate, { once: true });
    trigger.addEventListener('focusin', activate, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-cards"] && !Shopify.designMode) return;
  try {
    
  (function setupInfoCardDrawers() {
    // Delegated so it also covers drawers cloned in when a deferred section activates.
    if (window.__infoCardDrawersReady) return;
    window.__infoCardDrawersReady = true;

    let lastFocus = null;
    const timers = new WeakMap();
    const panelOf = (drawer) => drawer.querySelector('[data-info-drawer-panel]');
    const overlayOf = (drawer) => drawer.querySelector('[data-info-drawer-overlay]');

    const openDrawer = (drawer, trigger) => {
      const panel = panelOf(drawer);
      if (!panel) return;
      const overlay = overlayOf(drawer);
      lastFocus = trigger || document.activeElement;
      window.clearTimeout(timers.get(drawer));
      panel.hidden = false;
      requestAnimationFrame(() => {
        panel.dataset.active = '';
        if (overlay) overlay.dataset.active = '';
        panel.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    };

    const closeDrawer = (drawer) => {
      const panel = panelOf(drawer);
      if (!panel) return;
      const overlay = overlayOf(drawer);
      delete panel.dataset.active;
      if (overlay) delete overlay.dataset.active;
      document.documentElement.style.overflow = '';
      timers.set(drawer, window.setTimeout(() => { panel.hidden = true; }, 300));
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    };

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-info-drawer-open]');
      if (opener) {
        const drawer = document.querySelector('[data-info-drawer="' + opener.getAttribute('data-info-drawer-open') + '"]');
        if (drawer) { e.preventDefault(); openDrawer(drawer, opener); }
        return;
      }
      const closer = e.target.closest('[data-info-drawer-close], [data-info-drawer-overlay]');
      if (closer) {
        const drawer = closer.closest('[data-info-drawer]');
        if (drawer) closeDrawer(drawer);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-info-drawer]').forEach((drawer) => {
        const panel = panelOf(drawer);
        if (panel && panel.dataset.active !== undefined) closeDrawer(drawer);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  class MainCollection extends HTMLElement {
    // Resolved on demand. Filters, the grid and the drawer are all re-rendered
    // independently of this element - by load-more, by a filter submit, or by a
    // test variant - so a ref captured at connect time goes stale under us.
    get form() { return this.querySelector('[data-mc-form]'); }
    get drawer() { return this.querySelector('[data-mc-drawer]'); }
    get drawerPanel() { return this.querySelector('[data-mc-drawer-panel]'); }
    get drawerForm() { return this.querySelector('[data-mc-drawer-form]'); }
    get grid() { return this.querySelector('[data-mc-grid]'); }

    connectedCallback() {
      // Also fires when the element is merely moved; the delegated listeners
      // below live on `this` and survive that, so binding again would double up.
      if (this._bound) return;
      this._bound = true;

      // Next-page URLs appended by load-more, in order, and those pages' cards -
      // what _saveGrid() keeps for the way back. Taken over from the inline
      // restore when it already put them on the page.
      const restored = window.__mcRestored;
      this._loadedPages = restored ? restored.pages.slice() : [];
      this._appendedHtml = restored ? restored.html : '';
      try { history.scrollRestoration = 'manual'; } catch (e) {}
      window.addEventListener('pagehide', () => this._keepPos());
      // Also on the click itself: pagehide is not guaranteed on iOS.
      this.addEventListener('click', (e) => {
        if (e.target.closest && e.target.closest('[data-mc-grid] a')) this._keepPos();
      }, true);
      const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      if (nav.type === 'back_forward' && !restored) this._putBack();
      // iPhone Safari usually brings the page back frozen (the back-forward
      // cache), so the line above never runs - and with scroll restoration off
      // it would show the top. The pages are still there; just scroll.
      window.addEventListener('pageshow', (e) => { if (e.persisted) this._putBack(); });

      ThemeBind.delegate(this, 'click', '[data-mc-loadmore-button]', (e, btn) => {
        e.preventDefault();
        this._loadMore(btn);
      });

      ThemeBind.delegate(this, 'click', '[data-mc-open-drawer]', () => this._openDrawer());
      ThemeBind.delegate(this, 'click', '[data-mc-drawer-close]', () => this._closeDrawer());
      ThemeBind.delegate(this, 'click', '[data-mc-drawer-overlay]', () => this._closeDrawer());

      // Auto-submit on inline checkbox / sort change
      ThemeBind.delegate(this, 'change', '[data-mc-auto-submit]', () => {
        const form = this.form;
        if (form) this._submitForm(form);
      });
    }

    _openDrawer() {
      const drawer = this.drawer;
      if (!drawer) return;
      drawer.classList.remove('invisible', 'opacity-0');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        const panel = this.drawerPanel;
        if (panel) panel.setAttribute('data-open', '');
      });
    }

    _closeDrawer() {
      const drawer = this.drawer;
      if (!drawer) return;
      const panel = this.drawerPanel;
      if (panel) panel.removeAttribute('data-open');
      drawer.classList.add('opacity-0');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => {
        // Re-resolve: the drawer may have been replaced during the transition.
        const current = this.drawer;
        if (current) current.classList.add('invisible');
      }, 200);
    }

    async _loadMore(btn) {
      const url = btn.getAttribute('data-next-url');
      if (!url || btn.hasAttribute('data-loading')) return;

      const label = btn.querySelector('[data-mc-loadmore-label]');
      const restore = label ? label.textContent : '';
      btn.setAttribute('data-loading', '');
      if (label) label.textContent = btn.getAttribute('data-loading-label') || restore;

      try {
        this._appendPage(await this._fetchPage(url), btn);
        this._loadedPages.push(url);
        this._saveGrid();
        if (label) label.textContent = restore;
        btn.removeAttribute('data-loading');
      } catch (e) {
        // Fall back to a normal page navigation if the fetch fails.
        window.location.href = url;
      }
    }

    // Just this section (section_id), not the whole page - header, footer and
    // all - so each page arrives faster. A request the inline script above
    // already started on the way back is used instead of a new one.
    async _fetchPage(url) {
      const early = window.__mcPrefetch && window.__mcPrefetch[url];
      if (early) delete window.__mcPrefetch[url];
      const html = await (early || fetch(this._sectionUrl(url)).then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      }));
      return new DOMParser().parseFromString(html, 'text/html');
    }

    _sectionUrl(url, keep = true) {
      const u = new URL(url, location.href);
      if (keep && this.dataset.sectionId) u.searchParams.set('section_id', this.dataset.sectionId);
      else u.searchParams.delete('section_id');
      return u.pathname + u.search;
    }

    // Adds one fetched page to the grid - shared by load-more and the restore
    // on the way back from a product.
    _appendPage(doc, btn) {
      // Append the next page's grid items (products + any anchor blocks).
      const newGrid = doc.querySelector('[data-mc-grid]');
      const grid = this.grid;
      if (newGrid && grid) {
        const frag = document.createDocumentFragment();
        Array.from(newGrid.children).forEach((li) => {
          // Markup as it arrived, before anything on the page upgrades it.
          this._appendedHtml += li.outerHTML;
          frag.appendChild(document.importNode(li, true));
        });
        grid.appendChild(frag);
      }

      // Update the "Viewing 1 – N of M products" tally.
      const newShown = doc.querySelector('[data-mc-shown]');
      const curShown = this.querySelector('[data-mc-shown]');
      if (newShown && curShown) curShown.textContent = newShown.textContent;

      // Point the button at the following page, or retire it on the last page.
      if (!btn) return;
      const nextBtn = doc.querySelector('[data-mc-loadmore-button]');
      if (nextBtn) {
        // A section response can carry section_id in its paginate URLs; the
        // button is a real link too, so keep it pointing at the full page.
        const nextUrl = this._sectionUrl(nextBtn.getAttribute('data-next-url'), false);
        btn.setAttribute('data-next-url', nextUrl);
        btn.setAttribute('href', nextUrl);
      } else {
        btn.remove();
      }
    }

    // ----- Back from a product -----
    // Swiping back from a PDP put the shopper at the top of page 1: the
    // "Load more" pages were gone, so the browser's own scroll restore had
    // nothing to scroll to. Where they were and which pages they had loaded
    // are kept for this address (filters and sort included), and put back
    // when they return. Same approach as the search page (kukoon-search.js).
    _keepPos() {
      try {
        sessionStorage.setItem('kk.collectionpos', JSON.stringify({
          u: location.pathname + location.search,
          y: window.scrollY,
          pages: this._loadedPages,
          at: Date.now(),
        }));
      } catch (e) {}
    }

    // The cards load-more added, for the inline restore after the grid. Over
    // the storage quota it is dropped and the way back fetches the pages again.
    _saveGrid() {
      const shown = this.querySelector('[data-mc-shown]');
      const btn = this.querySelector('[data-mc-loadmore-button]');
      try {
        sessionStorage.setItem('kk.collectiongrid', JSON.stringify({
          u: location.pathname + location.search,
          pages: this._loadedPages,
          html: this._appendedHtml,
          shown: shown ? shown.textContent : '',
          next: btn ? btn.getAttribute('data-next-url') : null,
        }));
      } catch (e) {
        try { sessionStorage.removeItem('kk.collectiongrid'); } catch (e2) {}
      }
    }

    async _putBack() {
      let p = null;
      try { p = JSON.parse(sessionStorage.getItem('kk.collectionpos') || 'null'); } catch (e) {}
      if (!p || p.u !== location.pathname + location.search || Date.now() - p.at > 30 * 60 * 1000) return;

      // Pages not on screen yet - a full reload rather than the back-forward
      // cache. Fetched together, appended in order.
      const missing = (p.pages || []).slice(this._loadedPages.length, 20);
      if (missing.length) {
        const btn = this.querySelector('[data-mc-loadmore-button]');
        if (btn) btn.setAttribute('data-loading', '');
        try {
          const docs = await Promise.all(missing.map((url) => this._fetchPage(url)));
          docs.forEach((doc, i) => {
            this._appendPage(doc, this.querySelector('[data-mc-loadmore-button]'));
            this._loadedPages.push(missing[i]);
          });
        } catch (e) {
          // Keep whatever made it; scroll as far as the page now goes.
        }
        this._saveGrid();
        const after = this.querySelector('[data-mc-loadmore-button]');
        if (after) after.removeAttribute('data-loading');
      }

      const go = () => window.scrollTo(0, p.y);
      go(); requestAnimationFrame(go); setTimeout(go, 350);   // again once images have taken their space
    }

    _submitForm(form) {
      const formData = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        if (value) params.append(key, value);
      }
      const url = `${window.location.pathname}?${params.toString()}`;
      window.location.href = url;
    }
  }
  customElements.define('main-collection', MainCollection);

  // Document-level behaviour registered once for the page. Previously these
  // went on inside connectedCallback - one listener per dropdown, plus one for
  // Escape - so every re-render of the section left another live copy behind,
  // all of them still holding the elements they were created against.
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-mc-filter-dropdown][open]').forEach((details) => {
      if (!details.contains(e.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('main-collection').forEach((section) => {
      const drawer = section.querySelector('[data-mc-drawer]');
      if (drawer && !drawer.classList.contains('invisible')) section._closeDrawer();
    });
  });

  class CardMediaSlider extends HTMLElement {
    // Looked up on use: a card's media can be re-rendered underneath the slider
    // (load-more clones, quick-buy re-renders, a swapped-in grid).
    get track() { return this.querySelector('[data-card-track]'); }
    get slides() { return Array.from(this.querySelectorAll('[data-card-slide]')); }
    get prevBtn() { return this.querySelector('[data-card-prev]'); }
    get nextBtn() { return this.querySelector('[data-card-next]'); }
    get progressFill() {
      // The pagination bar lives outside this element (underneath the image box),
      // so reach it through the shared card root.
      const root = this.closest('[data-quickbuy-root]') || this;
      return root.querySelector('[data-card-progress-fill]');
    }

    connectedCallback() {
      const track = this.track;
      if (!track || this.slides.length < 2) return;

      this.activeIndex = 0;
      this._setActive(0);
      this._observeSlides();

      // Desktop: hovering the card jumps instantly to the hover image (slide 2)
      // and back to the featured image on leave.
      this._onEnter = this._onEnter || (() => {
        if (!this._isDesktop()) return;
        const slides = this.slides;
        if (slides[1]) this.track.scrollTo({ left: slides[1].offsetLeft, behavior: 'auto' });
      });
      this._onLeave = this._onLeave || (() => {
        if (!this._isDesktop()) return;
        this.track.scrollTo({ left: 0, behavior: 'auto' });
      });
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);

      // Arrow clicks are delegated so they keep working when the slides (and
      // the arrows with them) are re-rendered. Bound once - this element keeps
      // the listener across a disconnect/reconnect.
      if (!this._bound) {
        this._bound = true;
        ThemeBind.delegate(this, 'click', '[data-card-prev]', (e) => {
          e.preventDefault();
          this._go(-1);
        });
        ThemeBind.delegate(this, 'click', '[data-card-next]', (e) => {
          e.preventDefault();
          this._go(1);
        });
        // Re-observe when the slides themselves change; the old observer is
        // watching nodes that are no longer on the page.
        ThemeBind.onSwap(this, () => this._observeSlides());
      }

      // The first slider on the page gives a one-time elastic "peek" hint so
      // shoppers can tell the card image is swipeable.
      if (!CardMediaSlider._hinted) {
        CardMediaSlider._hinted = true;
        this._scheduleHint();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
    }

    _observeSlides() {
      const track = this.track;
      const slides = this.slides;
      if (!track || slides.length < 2) return;
      if (this.observer) this.observer.disconnect();
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this._setActive(this.slides.indexOf(entry.target));
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach((slide) => this.observer.observe(slide));
    }

    _isDesktop() {
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    _go(dir) {
      const track = this.track;
      const slides = this.slides;
      if (!track || !slides.length) return;
      const target = Math.min(Math.max(this.activeIndex + dir, 0), slides.length - 1);
      track.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
    }

    _scheduleHint() {
      // Mobile-only: the swipe hint is irrelevant on desktop (lg and up).
      if (window.matchMedia('(min-width: 1024px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setTimeout(() => requestAnimationFrame(() => this._peekHint()), 650);
    }

    _peekHint() {
      const track = this.track;
      const slide = this.slides[0];
      if (!track || !slide) return;
      const peek = slide.getBoundingClientRect().width * 0.25;
      if (peek <= 0) return;

      const prevBehavior = track.style.scrollBehavior;
      const prevSnap = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';

      const easeOut = (t) => 1 - Math.pow(1 - t, 3);

      const outMs = 750;
      const backMs = 750;
      const start = performance.now();
      const step = (now) => {
        // The track can be replaced mid-animation; stop rather than write to a
        // node that is no longer on the page.
        if (!track.isConnected) return;
        const elapsed = now - start;
        if (elapsed < outMs) {
          track.scrollLeft = peek * easeOut(elapsed / outMs);
        } else if (elapsed < outMs + backMs) {
          track.scrollLeft = Math.max(0, peek * (1 - easeOut((elapsed - outMs) / backMs)));
        } else {
          track.scrollLeft = 0;
          track.style.scrollBehavior = prevBehavior;
          track.style.scrollSnapType = prevSnap;
          return;
        }
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    _setActive(index) {
      if (index < 0) return;
      this.activeIndex = index;
      // The fill is one segment wide, so translating by index segments (its own
      // width = 100%) lands it under the active slide.
      const fill = this.progressFill;
      if (fill) fill.style.transform = `translateX(${index * 100}%)`;
      // Only show an arrow when it has somewhere to go.
      const prev = this.prevBtn;
      const next = this.nextBtn;
      if (prev) prev.toggleAttribute('data-disabled', index <= 0);
      if (next) next.toggleAttribute('data-disabled', index >= this.slides.length - 1);
    }
  }
  customElements.define('card-media-slider', CardMediaSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Market-prefixed cart endpoints. 
  // so these come from window.routes (set in theme.liquid). A bare '/cart/add.js'
  // from an /en-fr page resolves in the default market and can return GBP pricing.
  const pdpCartRoute = (key, fallback) => `${(window.routes && window.routes[key]) || fallback}.js`;

  // ----- Gallery sliders (mobile + desktop) + thumbnails + counters -----
  // Both breakpoints are horizontal snap sliders, one media per slide.
  // Each slide carries data-full (the width:1200 URL) so a variant change
  // can scroll the gallery to the variant's image by matching that URL.
  //
  // Nothing here holds a slider, arrow or thumbnail reference. The gallery is
  // one of the regions a test variant replaces outright, and both the cached
  // refs and the per-thumb click handlers died with the markup they were taken
  // from. Elements are resolved on use, controls are delegated on document, and
  // the registrations live at module scope so re-initialising a swapped-in form
  // can never bind them twice.
  const PDP_GALLERIES = [
    {
      slider: '[data-pdp-slider]',
      current: '[data-pdp-slider-current]',
      prev: '[data-pdp-slider-prev]',
      next: '[data-pdp-slider-next]',
      thumb: null,
    },
    {
      slider: '[data-pdp-d-slider]',
      current: '[data-pdp-d-current]',
      prev: '[data-pdp-d-prev]',
      next: '[data-pdp-d-next]',
      thumb: '[data-pdp-d-thumb]',
    },
  ];

  const pdpSliderIndex = (s) => (s && s.clientWidth ? Math.round(s.scrollLeft / s.clientWidth) : 0);
  const pdpScrollSliderTo = (s, index) => {
    if (s) s.scrollTo({ left: index * s.clientWidth, behavior: 'smooth' });
  };
  const pdpSlider = (root, g) => root && root.querySelector(g.slider);
  const pdpThumbs = (root, g) => (root && g.thumb ? ThemeBind.all(g.thumb, root) : []);

  // "Last synced index", keyed on the slider element rather than held in a
  // closure, so a replacement slider starts clean instead of inheriting the
  // scroll position of the one it replaced.
  const pdpLastIndex = new WeakMap();

  function pdpSyncGallery(root, g) {
    const slider = pdpSlider(root, g);
    if (!slider) return;
    const i = pdpSliderIndex(slider);
    const currentEl = root.querySelector(g.current);
    if (currentEl) currentEl.textContent = i + 1;
    const thumbs = pdpThumbs(root, g);
    thumbs.forEach((t, ti) => t.setAttribute('aria-current', ti === i ? 'true' : 'false'));
    // Slide the thumbnail row so the active thumb stays centred in view.
    if (pdpLastIndex.get(slider) !== i && thumbs[i]) {
      const li = thumbs[i].parentElement;
      const row = li.parentElement;
      const rowRect = row.getBoundingClientRect();
      const liRect = li.getBoundingClientRect();
      const delta = (liRect.left + liRect.width / 2) - (rowRect.left + rowRect.width / 2);
      if (Math.abs(delta) > 1) row.scrollBy({ left: delta, behavior: 'smooth' });
    }
    pdpLastIndex.set(slider, i);
  }

  // Scroll both galleries in `root` to the slide whose image matches `url`.
  function pdpShowImage(root, url) {
    if (!url || !root) return;
    PDP_GALLERIES.forEach((g) => {
      const slider = pdpSlider(root, g);
      if (!slider) return;
      const slides = slider.querySelectorAll('[data-full]');
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].dataset.full === url) { pdpScrollSliderTo(slider, i); break; }
      }
    });
  }

  PDP_GALLERIES.forEach((g) => {
    let ticking = false;
    // `scroll` does not bubble, so it has to be delegated in the capture phase.
    ThemeBind.on('scroll', g.slider, function () {
      const root = this.closest('section');
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => { pdpSyncGallery(root, g); ticking = false; });
    }, { capture: true, passive: true });

    ThemeBind.on('click', g.prev, function () {
      const slider = pdpSlider(this.closest('section'), g);
      pdpScrollSliderTo(slider, Math.max(0, pdpSliderIndex(slider) - 1));
    });

    ThemeBind.on('click', g.next, function () {
      const slider = pdpSlider(this.closest('section'), g);
      if (slider) pdpScrollSliderTo(slider, Math.min(slider.children.length - 1, pdpSliderIndex(slider) + 1));
    });

    if (g.thumb) {
      ThemeBind.on('click', g.thumb, function () {
        const root = this.closest('section');
        pdpScrollSliderTo(pdpSlider(root, g), pdpThumbs(root, g).indexOf(this));
      });
    }

    // Counter and thumbnail state for the slides on the page now, and again for
    // any slider swapped in later.
    ThemeBind.ready(g.slider, (slider) => pdpSyncGallery(slider.closest('section'), g));
  });

  // ----- Autoplay gallery videos when scrolled into view -----
  // Videos are muted + playsinline so browsers allow programmatic play.
  // The observer clips against the horizontal snap slider, so a video only
  // plays while its slide is the visible one AND in the vertical viewport.
  // One observer for the page, fed by ready() - a video that arrives with a
  // swapped-in gallery is observed the same as one that was in the original
  // markup, and detached videos simply stop reporting intersections.
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const pdpVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // The page carries two galleries (phone and desktop), each with its
          // own copy of the video, and both used to buffer it: every segment
          // downloaded twice, ~6.6 MB wasted per product page (audit, 9 Oct
          // 2026). Sources now arrive as data-src and are attached only when a
          // video is actually on screen - the hidden gallery's never is.
          if (!video.dataset.loaded) {
            video.dataset.loaded = '1';
            video.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; });
            video.load();
          }
          const played = video.play();
          if (played && played.catch) played.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5, 1] });
    ThemeBind.ready('[data-pdp-video]', (video) => pdpVideoObserver.observe(video));
  }

  // Init once per form element - and again for any form Intelligems (or the
  // theme editor, or a Section Rendering API call) swaps in later. A one-shot
  // `document.querySelectorAll(...).forEach(...)` at parse time never ran
  // against replacement markup, which is what left the PDP inert after a test
  // variant rendered.
  ThemeBind.ready('[data-pdp-form]', (form) => {
    const root = form.closest('section');

    // ----- Variant selection -----
    // Every one of these is resolved on use rather than captured. A test
    // variant can replace the price block, the option selectors or the submit
    // button independently of the form around them, and a ref taken here would
    // still be pointing at the markup that was thrown away.
    const variantSelect = () => form.querySelector('[data-pdp-variant-id]');
    const optionInputs = () => form.querySelectorAll('[data-pdp-option]');
    const submitBtn = () => form.querySelector('[data-pdp-submit]');
    const submitLabelEl = () => form.querySelector('[data-pdp-submit-label]');
    const priceEl = () => root.querySelector('[data-pdp-price]');
    const availabilityEl = () => root.querySelector('[data-pdp-availability]');
    const stockDotEl = () => root.querySelector('[data-pdp-stock-dot]');

    const strings = {
      addToCart: form.dataset.stringAddToCart || 'Add to basket',
      soldOut: form.dataset.stringSoldOut || 'Sold out',
      unavailable: form.dataset.stringUnavailable || 'Unavailable',
    };

    const STOCK_DOT_CLASSES = ['bg-green-500', 'bg-orange-500', 'bg-red-500'];
    const stockStates = {
      in_stock: { dot: 'bg-green-500', label: form.dataset.stringInStock || 'In stock' },
      low_stock: { dot: 'bg-orange-500', label: form.dataset.stringLowStock || 'Low stock' },
      pre_order: { dot: 'bg-orange-500', label: form.dataset.stringPreOrder || 'Pre-order' },
      out_of_stock: { dot: 'bg-red-500', label: strings.soldOut },
    };
    const applyStockState = (state) => {
      const info = stockStates[state] || stockStates.in_stock;
      const dot = stockDotEl();
      if (dot) {
        dot.classList.remove(...STOCK_DOT_CLASSES);
        dot.classList.add(info.dot);
      }
      const availability = availabilityEl();
      if (availability) availability.textContent = info.label;
    };

    // Wired unconditionally: the variant <select> may be absent right now and
    // arrive with a swap, so the guard belongs inside update(), not around the
    // registration.
    {
      const selectedOptions = () => {
        const byIndex = {};
        optionInputs().forEach((input) => {
          if (input.checked) byIndex[input.dataset.optionIndex] = input.value;
        });
        const out = [];
        for (let i = 0; byIndex[i] !== undefined; i++) out.push(byIndex[i]);
        return out;
      };

      // The variant the page is MEANT to show, independent of the option inputs.
      // ?variant= is Shopify's own selection carrier - it is how the page was
      // loaded, and announceVariant() keeps it current on every change - so it
      // survives any amount of markup replacement. The <select> is the fallback
      // for a page loaded without one.
      const intendedVariantId = () => {
        try {
          const fromUrl = new URL(window.location.href).searchParams.get('variant');
          if (fromUrl) return fromUrl;
        } catch (e) {}
        const select = variantSelect();
        return select ? select.value : '';
      };

      // The reverse of selectedOptions(): set the inputs to describe `matched`.
      // `.checked` is a property write, not an attribute, so it does not feed
      // the mutation observer below.
      const checkOptionsFor = (matched) => {
        const values = (matched.dataset.variantOptions || '').split(' / ');
        optionInputs().forEach((input) => {
          const idx = parseInt(input.dataset.optionIndex, 10);
          input.checked = values[idx] !== undefined && input.value === values[idx];
        });
      };

      const announceVariant = (select, matched, available) => {
        if (history.replaceState) {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', matched.value);
            history.replaceState(history.state, '', url.toString());
          } catch (e) {}
        }
        select.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: {
              variant: {
                id: Number(matched.value),
                available: available,
                title: matched.dataset.variantOptions || '',
              },
            },
          })
        );
      };

      const update = () => {
        const select = variantSelect();
        if (!select) return;
        const target = selectedOptions().join(' / ');
        let matched = null;
        select.querySelectorAll('option').forEach((opt) => {
          if (opt.dataset.variantOptions === target) matched = opt;
        });

        const btn = submitBtn();
        const label = submitLabelEl();
        if (!matched) {
          if (btn) btn.disabled = true;
          if (label) label.textContent = strings.unavailable;
          return;
        }

        select.value = matched.value;
        const available = matched.dataset.variantAvailable === 'true';
        if (btn) btn.disabled = !available;
        if (label) label.textContent = available ? strings.addToCart : strings.soldOut;
        announceVariant(select, matched, available);

        const price$el = priceEl();
        if (price$el) {
          const price = matched.dataset.variantPrice;
          const compare = matched.dataset.variantCompareAtPrice;
          const discount = matched.dataset.variantDiscount;
          price$el.innerHTML = compare
            ? '<span class="font-semibold text-(--color-fg)">' + price + '</span>' +
              '<span class="inline-flex h-[18px] w-[50px] items-center justify-center bg-[#E6CAD0] font-sans text-[12px] font-medium leading-[20px] tracking-[-0.03em] text-[#450E22]">-' + discount + '%</span>' +
              '<span class="font-sans text-[14px] font-normal leading-[22px] tracking-[-0.03em] text-[#777777] line-through">' + compare + '</span>'
            : '<span class="font-semibold text-(--color-fg)">' + price + '</span>';
        }
        applyStockState(matched.dataset.variantStockState);
        if (matched.dataset.variantImage) {
          pdpShowImage(root, matched.dataset.variantImage);
        }
        updateUnderlayForVariant(matched);
        updateUrgencyNoteForVariant(matched);
      };

      // Delegated rather than bound per input: `change` bubbles, so one
      // listener on the form keeps working no matter how many times the
      // selectors inside it are replaced. Binding per element broke as soon as
      // Intelligems swapped the markup.
      ThemeBind.delegate(form, 'change', '[data-pdp-option]', update);

      // Delegation covers interaction, but a swap can also land with the inputs
      // describing a different variant from the one the shopper is looking at.
      // The replacement markup is rendered with whatever variant context the
      // test tool had - not the page's ?variant=x - so on a PDP loaded with a
      // variant in the URL the swapped-in selector arrived with other options
      // checked (or none). update() then found no variant for that combination
      // and marked the button "Unavailable", under a price that was still right
      // because the swap had painted it.
      //
      // So a swap is not treated like a click. The inputs are re-pointed at the
      // intended variant FIRST, and only then does update() run against them.
      const resync = () => {
        const select = variantSelect();
        if (!select) return;
        const intended = intendedVariantId();
        const matched = intended ? select.querySelector('option[value="' + intended + '"]') : null;
        if (matched) checkOptionsFor(matched);
        update();
      };

      // Signature-guarded so this can't loop: update() writes price/label/
      // dataset but never adds or removes an option input, and the re-check in
      // resync() is a property write the observer never sees. The signature is
      // re-taken after the run so the re-checked state is the new baseline.
      const signature = () =>
        Array.prototype.map
          .call(optionInputs(), (i) => i.id + ':' + i.value + ':' + (i.checked ? 1 : 0))
          .join('|');
      let lastSignature = signature();
      ThemeBind.onSwap(form, () => {
        if (signature() === lastSignature) return;
        resync();
        lastSignature = signature();
      });

      // A swap can also land before this script runs, leaving no mutation to
      // observe. Check once now, and repair only if the inputs actually
      // disagree with the intended variant - a clean load must not re-announce
      // the variant it was rendered with.
      {
        const select = variantSelect();
        const intended = select ? intendedVariantId() : '';
        const matched = intended ? select.querySelector('option[value="' + intended + '"]') : null;
        if (matched && selectedOptions().join(' / ') !== matched.dataset.variantOptions) {
          resync();
          lastSignature = signature();
        }

        // And on a load that named a variant, show that variant's own picture -
        // the picture the shopper clicked. update() does this on a change, but
        // a clean load deliberately does not run it, so a PDP opened from a
        // search for a round rug showed the rectangle. Nothing is announced
        // here: no history, no events, just the gallery moving to the shot the
        // variant already carries.
        if (matched && matched.dataset.variantImage) {
          pdpShowImage(root, matched.dataset.variantImage);
        }
      }
    }

    // ----- Size unit toggle (cm / ft) -----
    {
      const unitButtons = () => ThemeBind.all('[data-size-unit-toggle] [data-size-unit]', form);
      const sizeLabels = () => ThemeBind.all('[data-size-display]', form);

      const cmToFt = (str) => {
        if (!/cm/i.test(str)) return str;
        return str
          .replace(/cm/gi, '')
          .replace(/\d+(?:\.\d+)?/g, (n) => {
            const inches = parseFloat(n) / 2.54;
            let ft = Math.floor(inches / 12);
            let inch = Math.round(inches - ft * 12);
            if (inch === 12) { ft += 1; inch = 0; }
            return inch ? ft + "'" + inch + '"' : ft + "'";
          })
          .replace(/\s+/g, ' ')
          .trim();
      };

      const labelFor = (el, unit) => (unit === 'ft' ? cmToFt(el.dataset.sizeCm) : el.dataset.sizeCm);

      const applyUnit = (unit) => {
        sizeLabels().forEach((el) => { el.textContent = labelFor(el, unit); });
        unitButtons().forEach((btn) => {
          const active = btn.dataset.sizeUnit === unit;
          if (active) btn.dataset.active = '';
          else delete btn.dataset.active;
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      // The chosen unit lives on the form rather than in a closure variable, so
      // it survives this callback being re-run for a swapped-in form.
      ThemeBind.delegate(form, 'click', '[data-size-unit]', function () {
        form.dataset.sizeUnit = this.dataset.sizeUnit;
        applyUnit(this.dataset.sizeUnit);
      });

      // Swapped-in sizes render in cm; put the shopper's choice back. The stale
      // check makes this a no-op when the labels are already right, which is
      // what stops it re-triggering its own observer.
      ThemeBind.onSwap(form, () => {
        const unit = form.dataset.sizeUnit;
        if (!unit || unit === 'cm') return;
        const stale = sizeLabels().some((el) => el.textContent !== labelFor(el, unit));
        if (stale) applyUnit(unit);
      });
    }

    // ----- Dispatch countdown -----
    {
      const dispatches = () => ThemeBind.all('[data-pdp-dispatch]', form);
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      const ordinal = (n) => {
        const s = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
      };

      // The cutoff is a WAREHOUSE time, not a shopper-local one. Using the browser
      // clock meant a CET shopper (FR/DE/ES) saw the countdown an hour out and was
      // promised a dispatch date the warehouse could not hit. Resolve "now" in the
      // warehouse timezone so every market counts down to the same real instant.
      const WAREHOUSE_TZ = 'Europe/London';
      const warehouseNow = () => {
        try {
          return new Date(new Date().toLocaleString('en-US', { timeZone: WAREHOUSE_TZ }));
        } catch (e) {
          return new Date();
        }
      };

      const tick = () => {
        const blocks = dispatches();
        if (!blocks.length) return;
        // Read the cutoff off the markup on every tick - a swapped-in dispatch
        // block can carry a different cutoff to the one that was on the page
        // when this ran the first time.
        const cutoffHour = parseInt(blocks[0].dataset.cutoffHour, 10) || 16;
        const dispatchDays = parseInt(blocks[0].dataset.dispatchDays, 10) || 1;

        const now = warehouseNow();
        const cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);

        let offset = dispatchDays;
        if (now > cutoff) {
          cutoff.setDate(cutoff.getDate() + 1);
          offset += 1;
        }

        const diff = cutoff - now;
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const countdownText = h + ' hr ' + m + ' mins';

        const dispatchDate = new Date(now);
        dispatchDate.setDate(dispatchDate.getDate() + offset);
        const dateText = days[dispatchDate.getDay()] + ' ' + ordinal(dispatchDate.getDate()) + ' ' + months[dispatchDate.getMonth()];

        blocks.forEach((dispatch) => {
          const countdownEl = dispatch.querySelector('[data-pdp-countdown]');
          const dateEl = dispatch.querySelector('[data-pdp-dispatch-date]');
          // Only write when the value actually changed: that makes tick() a
          // no-op against correct markup, which is what lets onSwap below call
          // it without the write re-triggering the observer.
          if (countdownEl && countdownEl.textContent !== countdownText) countdownEl.textContent = countdownText;
          if (dateEl && dateEl.textContent !== dateText) dateEl.textContent = dateText;
        });
      };

      tick();
      // Stops itself once the form leaves the page, so a swap doesn't leave the
      // previous form's timer ticking against detached nodes forever.
      ThemeBind.every(form, 60000, tick);
      // A swapped-in countdown renders with placeholder text; fill it straight
      // away rather than leaving it wrong for up to a minute.
      ThemeBind.onSwap(form, tick);
    }

    // ----- Anti-slip underlay (deferred - committed with the rug) -----
    // Selecting the underlay does NOT touch the cart; it only records intent.
    // The underlay line is created when the rug is added to the cart
    // (`commitUnderlay`, called from the submit handler below). It can be
    // removed before the rug is added (just deselects) or after (also drops
    // the committed cart line). Switching the size selector only changes what's
    // displayed - it never mutates the cart, because a committed underlay stays
    // attached to whichever rug is actually in the cart (re-pointing it onto a
    // not-yet-added size would strand it with no parent). `updateUnderlayForVariant`
    // is a hoisted declaration so the variant `update()` above can call it.
    //
    // The card is re-rendered by the variant `update()` and can be replaced
    // outright by a test variant, so every part of it is looked up on use.
    const antislipCard = () => root.querySelector('[data-antislip-card]');
    const inCard = (sel) => root.querySelector('[data-antislip-card] ' + sel);
    const antislipButton = () => inCard('[data-antislip-add]');
    const antislipAddedGroup = () => inCard('[data-antislip-added]');
    const antislipImage = () => inCard('[data-antislip-image]');
    const antislipPrice = () => inCard('[data-antislip-price]');
    const antislipNote = () => root.querySelector('[data-antislip-note]');

    // The note under the underlay card is not part of the underlay: it carries the
    // "Outlet" discount notice or the product/variant urgency message, already
    // resolved per variant in Liquid onto each <option>. Hoisted so the variant
    // `update()` above can call it.
    function updateUrgencyNoteForVariant(matched) {
      // The variant update() can run as the page starts (an Intelligems swap that
      // lands before this script calls resync()), before the underlay helpers
      // below exist. Clarity logged that as 'cannot access antislipCard before
      // initialization' in ~42% of sessions with a script error (7-9 Oct 2026).
      // Hold the call until they do; it is replayed straight after.
      if (!root.__kkUnderlayReady) { root.__kkUnderlayPending = matched; return; }
      const note = antislipNote();
      if (!note) return;
      const message = matched.dataset.urgencyMessage || '';
      note.textContent = message;
      note.hidden = !message;
    }
    // `key` is the committed cart line - empty until the rug is added (or if
    // it was never in the cart). `parentVariantId` is the rug variant that line
    // is attached to, so we can tell when the displayed size is the committed one.
    const antislipState = (() => {
      const card = antislipCard();
      const button = antislipButton();
      return {
        key: card ? card.dataset.underlayKey || '' : '',
        variantId: button ? button.dataset.variantId || '' : '',
        parentVariantId: card && card.dataset.underlayKey ? card.dataset.parentVariantId || '' : '',
      };
    })();
    // Selected = the customer wants the underlay. Already-in-cart ⇒ selected.
    let antislipSelected = !!antislipState.key;

    // Toggles between the "Add" pill and the "Remove" group (matches the cart card).
    function setAntislipAdded(isAdded) {
      const flag = isAdded ? 'true' : 'false';
      [antislipButton(), antislipAddedGroup(), antislipCard()].forEach((el) => {
        if (el) el.dataset.added = flag;
      });
    }
    setAntislipAdded(antislipSelected);
    root.__kkUnderlayReady = true;
    if (root.__kkUnderlayPending) {
      const m = root.__kkUnderlayPending;
      root.__kkUnderlayPending = null;
      updateUnderlayForVariant(m);
      updateUrgencyNoteForVariant(m);
    }

    // A replacement card renders from Liquid with whatever "added" state the
    // page was built with, which is not necessarily the shopper's. Re-apply it.
    // Only dataset attributes are written here, and onSwap watches childList
    // only, so this cannot re-trigger itself.
    ThemeBind.onSwap(root, () => {
      const card = antislipCard();
      if (!card) return;
      const committedHere =
        !!antislipState.key &&
        String(antislipState.parentVariantId) === String(card.dataset.parentVariantId);
      setAntislipAdded(committedHere || antislipSelected);
    });

    function updateUnderlayForVariant(matched) {
      if (!root.__kkUnderlayReady) { root.__kkUnderlayPending = matched; return; }
      const card = antislipCard();
      if (!card) return;
      const id = matched.dataset.underlayId || '';
      const parentVariantId = matched.value;
      card.dataset.parentVariantId = parentVariantId;
      card.hidden = !id;

      if (id) {
        const button = antislipButton();
        if (button) {
          button.dataset.variantId = id;
          button.disabled = matched.dataset.underlayAvailable === 'false';
        }
        const image = antislipImage();
        if (image) {
          const img = matched.dataset.underlayImage || '';
          if (img) { image.src = img; image.hidden = false; }
          else { image.removeAttribute('src'); image.hidden = true; }
        }
        const price = antislipPrice();
        if (price && matched.dataset.underlayPrice) {
          price.textContent = matched.dataset.underlayPrice;
        }
      }

      // Switching the size selector never mutates the cart. Show "added" for
      // the size whose underlay is actually committed; for any other size,
      // reflect the customer's opt-in for the underlay they'd add with it.
      const committedHere =
        !!antislipState.key && String(antislipState.parentVariantId) === String(parentVariantId);
      setAntislipAdded(committedHere || antislipSelected);
    }

    // Select only - nothing is added until the rug is added to the cart.
    ThemeBind.delegate(root, 'click', '[data-antislip-add]', () => {
      antislipSelected = true;
      setAntislipAdded(true);
    });

    // Remove works before the rug is added (deselect) or after (also drops the
    // committed cart line). Only touch the cart when the displayed size is the
    // committed one - otherwise we'd drop another rug's underlay.
    ThemeBind.delegate(root, 'click', '[data-antislip-remove]', async function () {
      antislipSelected = false;
      setAntislipAdded(false);
      const card = antislipCard();
      const committedHere =
        !!antislipState.key &&
        !!card &&
        String(antislipState.parentVariantId) === String(card.dataset.parentVariantId);
      if (!committedHere || !window.UnderlayCart) return;
      // `this` is whichever remove button was actually clicked, so the disabled
      // state lands on the live element rather than on a captured one.
      this.disabled = true;
      try {
        await window.UnderlayCart.updateLines({ [antislipState.key]: 0 });
        antislipState.key = '';
        antislipState.variantId = '';
        antislipState.parentVariantId = '';
        window.UnderlayCart.refresh(false);
      } catch (e) {
        // Leave the line; the customer can retry.
      } finally {
        this.disabled = false;
      }
    });

    // Commit the selected underlay to the cart, linked to the just-added rug.
    async function commitUnderlay(parentVariantId) {
      if (!antislipCard() || !window.UnderlayCart || !parentVariantId) return;
      const button = antislipButton();
      const underlayId = button && button.dataset.variantId;
      if (!antislipSelected || !underlayId || (button && button.disabled)) return;
      let cart;
      try { cart = await window.UnderlayCart.getCart(); } catch (e) { return; }
      const existing = cart.items.find(
        (it) => it.properties && String(it.properties._underlay_for) === String(parentVariantId)
      );
      if (existing) {
        antislipState.key = existing.key;
        antislipState.variantId = underlayId;
        antislipState.parentVariantId = String(parentVariantId);
        return;
      }
      try {
        const line = await window.UnderlayCart.addUnderlay(underlayId, parentVariantId, 1);
        antislipState.key = (line && line.key) || '';
        antislipState.variantId = underlayId;
        antislipState.parentVariantId = String(parentVariantId);
        await window.UnderlayCart.reconcile();
      } catch (e) {
        // Non-fatal: the rug is already in the cart.
      }
    }

    // ----- Add to basket → AJAX add, then open the cart drawer -----
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = e.submitter || submitBtn();
      const label = btn && btn.querySelector('[data-pdp-submit-label]');
      const original = label ? label.textContent : null;
      if (btn) btn.disabled = true;

      try {
        let res;
        try {
          res = await fetch(pdpCartRoute('cart_add_url', '/cart/add'), {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
        } catch (netErr) {
          res = null;
        }
        if (!res || !res.ok) {
          // The RUG did not go in: fall back to a full form post so the
          // customer is never stuck. Only here - once the rug is in, a form
          // post would add it a second time.
          form.submit();
          return;
        }
        // The rug is in the basket. The underlay is a separate request, and
        // if it fails the rug must stay exactly once: open the drawer so the
        // customer sees what did go in, and they can add the underlay there.
        const idInput = form.querySelector('[name="id"]');
        const card = antislipCard();
        try {
          await commitUnderlay(
            idInput ? String(idInput.value) : card && card.dataset.parentVariantId
          );
        } catch (underlayErr) {
          console.warn('[pdp] rug added, underlay could not be added', underlayErr);
        }
        // Complete the set (assets/kukoon-set.js), when it is switched on,
        // comes INSTEAD of the drawer and opens it itself when it is done -
        // or straight away if it has nothing to offer. Otherwise, as before.
        if (window.KukoonSet && window.KukoonSet.active) {
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })
          );
          // This sits in the section's javascript block, where Liquid is NOT
          // rendered, so the handle comes from the page. (A Liquid output tag
          // here once broke the whole product page script - every add fell
          // back to a full form post to the basket page.)
          let kHandle = '';
          try {
            const pj = root.querySelector('[data-product-json]');
            kHandle = (pj && JSON.parse(pj.textContent).handle) || '';
          } catch (e) {}
          if (!kHandle) kHandle = decodeURIComponent((location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '');
          // the exact size just added, so the popup names that one - not the
          // first line of this product already in the basket
          const kVariant = String((form.querySelector('[name="id"]') || {}).value || '');
          if (kHandle) window.KukoonSet.afterAdd(kHandle, kVariant);
          else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        } else {
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
          );
        }
      } finally {
        if (btn) btn.disabled = false;
        if (label && original !== null) label.textContent = original;
      }
    });

    // ----- Tab switching (Rugs / Runners / Cushions) -----
    {
      const tabs = () => ThemeBind.all('[data-pdp-tab]', root);
      const panels = () => ThemeBind.all('[data-pdp-tab-panel]', root);
      const footers = () => ThemeBind.all('[data-pdp-footer]', root);

      const activate = (target) => {
        tabs().forEach((t) => t.setAttribute('aria-selected', t.dataset.pdpTabTarget === target ? 'true' : 'false'));
        panels().forEach((p) => { p.hidden = p.dataset.pdpTabPanel !== target; });
        const desired = target === 'cushions' || target === 'runner' ? target : 'product';
        const footerTarget = root.querySelector('[data-pdp-footer="' + desired + '"]') ? desired : 'product';
        footers().forEach((f) => { f.hidden = f.dataset.pdpFooter !== footerTarget; });
        const scrollArea = root.querySelector('[data-pdp-scroll]');
        if (scrollArea) scrollArea.scrollTop = 0;
      };

      ThemeBind.delegate(root, 'click', '[data-pdp-tab]', function () {
        activate(this.dataset.pdpTabTarget);
      });

      // Mobile "complete your room" promo → open the Cushions tab and scroll to it.
      ThemeBind.delegate(root, 'click', '[data-room-promo-cushions]', () => {
        const cushionsTab = root.querySelector('[data-pdp-tab][data-pdp-tab-target="cushions"]');
        if (!cushionsTab) return;
        activate('cushions');
        cushionsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Sync panel visibility with whichever tab is marked active - now, and
      // again whenever the tab strip is re-rendered under us. `activate` writes
      // only attributes and `hidden`, so it can't re-trigger this observer.
      const syncTabs = () => {
        const all = tabs();
        const panelEls = panels();
        if (!all.length || !panelEls.length) return;
        const initial = root.querySelector('[data-pdp-tab][aria-selected="true"]') || all[0];
        if (!initial) return;
        const target = initial.dataset.pdpTabTarget;
        // Only act when the panels don't already match the selected tab.
        // activate() resets the panel's scroll position, and this runs from an
        // observer that fires on any change in the section - including a price
        // repaint on variant change - so calling it unconditionally would jump
        // the shopper back to the top of the panel mid-browse.
        const inSync = panelEls.every((p) => p.hidden === (p.dataset.pdpTabPanel !== target));
        if (!inSync) activate(target);
      };
      syncTabs();
      ThemeBind.onSwap(root, syncTabs);
    }

    // ----- Cushions "complete your room" selector + bundle banner -----
    // Wired unconditionally and resolved on use: the cushions panel sits inside
    // a tab that a test variant can re-render, and holding the steppers, tiers
    // and footer controls in consts meant the whole panel went dead the moment
    // it did. All state that matters lives on the elements themselves
    // (data-qty, data-variant-id, aria-pressed), so nothing is lost by looking
    // them up fresh each time.
    {
      const cushionsEl = () => root.querySelector('[data-cushions]');
      const inCushions = (sel) => ThemeBind.all('[data-cushions] ' + sel, root);
      const tiers = () => inCushions('[data-cushions-tier]');
      const savingCells = () => inCushions('[data-cushions-saving]');
      const steppers = () => inCushions('[data-cushions-stepper]');
      const bundleBtns = () => inCushions('[data-cushions-bundle]');
      const fillEl = () => root.querySelector('[data-cushions-fill]');
      const footerQtyEl = () => root.querySelector('[data-cushions-footer-qty]');
      const addBtn = () => root.querySelector('[data-cushions-add]');
      const totalEl = () => root.querySelector('[data-cushions-total]');
      const saveBadgeEl = () => root.querySelector('[data-cushions-savebadge]');
      const compareEl = () => root.querySelector('[data-cushions-compare]');
      const hintEl = () => root.querySelector('[data-cushions-hint]');
      const hintMoreEl = () => root.querySelector('[data-cushions-hint-more]');
      const hintSaveEl = () => root.querySelector('[data-cushions-hint-save]');
      const productId = () => {
        const el = cushionsEl();
        return el ? el.dataset.productId : '';
      };
      const maxTier = () => tiers().length;
      const BUNDLE_PROP = '_bundle_for';

      // Write only when the value actually changes. Every render pass below goes
      // through this, which is what makes them safe to call from onSwap: against
      // already-correct markup they mutate nothing, so they cannot re-trigger
      // the observer that called them.
      const setText = (el, value) => {
        if (el && el.textContent !== String(value)) el.textContent = value;
      };

      const totalQty = () => {
        let n = 0;
        steppers().forEach((s) => { n += parseInt(s.dataset.qty, 10) || 0; });
        return n;
      };

      // Presentment money formatter. The shape (symbol position, separators, number
      // of decimals) is read from a real `{{ 111111 | money }}` sample rendered by
      // Liquid, so the JS-computed bundle total is byte-identical in style to the
      // static prices beside it in every market.
      //
      // This previously ran off shop.money_format, which is the SHOP's format (GBP)
      // regardless of market - so a euro shopper saw a correct euro amount rendered
      // as "£58.00" the moment they touched a stepper.
      //
      // Parsed lazily and memoised on the sample string rather than at init: the
      // panel carrying the sample may not be on the page yet.
      let moneyShape = null;
      let moneyShapeFor = null;
      const parseMoneyShape = (raw) => {
        const shape = { prefix: '', suffix: '', thousands: ',', decimal: '.', places: 2 };
        const sample = String(raw).replace(/<[^>]*>/g, '');
        const match = sample.match(/\d[\d\s.,' ]*\d|\d/);
        if (match) {
          const numeric = match[0];
          shape.prefix = sample.slice(0, match.index);
          shape.suffix = sample.slice(match.index + numeric.length);
          const groups = numeric.split(/[^\d]/);
          const seps = numeric.match(/[^\d]/g) || [];
          if (groups.length > 1 && groups[groups.length - 1].length === 2) {
            // Sample is 1111.11, so a 2-digit final group means decimals are shown.
            shape.places = 2;
            shape.decimal = seps[seps.length - 1];
            shape.thousands = seps.length > 1 ? seps[0] : '';
          } else {
            shape.places = 0;
            shape.thousands = seps.length ? seps[0] : '';
          }
        }
        return shape;
      };
      const formatMoney = (cents) => {
        const el = cushionsEl();
        const sample = (el && el.dataset.moneySample) || '1,111.11';
        if (moneyShapeFor !== sample) {
          moneyShapeFor = sample;
          moneyShape = parseMoneyShape(sample);
        }
        const fixed = (Math.round(cents) / 100).toFixed(moneyShape.places);
        const parts = fixed.split('.');
        const whole = moneyShape.thousands
          ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyShape.thousands)
          : parts[0];
        return moneyShape.prefix + whole + (parts[1] ? moneyShape.decimal + parts[1] : '') + moneyShape.suffix;
      };

      // Sum the selected cushions' price + compare-at total (in cents).
      const computeTotals = () => {
        let total = 0;
        let compare = 0;
        steppers().forEach((s) => {
          const q = parseInt(s.dataset.qty, 10) || 0;
          if (!q) return;
          const price = parseInt(s.dataset.priceCents, 10) || 0;
          const comp = parseInt(s.dataset.compareCents, 10) || price;
          total += price * q;
          compare += comp * q;
        });
        return { total, compare };
      };

      // Show/hide an element while preserving its intended display when shown.
      const toggleEl = (el, show, display) => {
        if (!el) return;
        el.classList.toggle('hidden', !show);
        el.classList.toggle(display, show);
      };

      // Footer price row: live total, % saved + struck compare-at (when discounted).
      const updateFooterPricing = () => {
        const { total, compare } = computeTotals();
        setText(totalEl(), formatMoney(total));
        const hasSaving = compare > total;
        const badge = saveBadgeEl();
        const compareLabel = compareEl();
        toggleEl(badge, hasSaving, 'inline-flex');
        if (hasSaving) setText(badge, '-' + Math.round(((compare - total) / compare) * 100) + '%');
        toggleEl(compareLabel, hasSaving, 'inline');
        if (hasSaving) setText(compareLabel, formatMoney(compare));
      };

      // Footer hint: "Add N more to save XX" - drives toward the 5+ tier, hides at 5+.
      const updateHint = () => {
        const tq = totalQty();
        const top = maxTier();
        const remaining = top - tq;
        const show = tq > 0 && remaining > 0;
        toggleEl(hintEl(), show, 'flex');
        if (!show) return;
        setText(hintMoreEl(), remaining);
        const topCell = root.querySelector('[data-cushions-saving][data-qty="' + top + '"]');
        setText(hintSaveEl(), topCell ? topCell.textContent.trim() : '');
      };

      // Green-fill the quantity tiers up to the running total (from the bundle
      // banner or any manual stepper) and stretch the connecting bar to match.
      const refreshTiers = () => {
        const total = totalQty();
        const active = Math.min(total, maxTier());
        tiers().forEach((el) => {
          const on = total > 0 && (parseInt(el.dataset.qty, 10) || 0) <= active;
          el.classList.toggle('bg-[#3E8E5A]', on);
          el.classList.toggle('bg-(--color-fg)', !on);
        });
        savingCells().forEach((el) => {
          const on = total > 0 && (parseInt(el.dataset.qty, 10) || 0) <= active;
          el.classList.toggle('text-(--color-fg)', on);
          el.classList.toggle('text-(--color-muted)', !on);
        });
        const fill = fillEl();
        if (fill) fill.style.width = (active > 1 ? (active - 1) * 20 : 0) + '%';
        setText(footerQtyEl(), total);
        const add = addBtn();
        if (add) add.disabled = total === 0;
        updateFooterPricing();
        updateHint();
      };

      // Reflect a stepper's qty into its own controls (count text, dec visibility).
      const syncStepper = (stepper) => {
        const q = parseInt(stepper.dataset.qty, 10) || 0;
        const count = stepper.querySelector('[data-cushions-count]');
        const dec = stepper.querySelector('[data-cushions-dec]');
        if (count) {
          setText(count, q);
          count.classList.toggle('hidden', q === 0);
        }
        if (dec) {
          dec.classList.toggle('hidden', q === 0);
          dec.classList.toggle('inline-flex', q > 0);
        }
      };

      const setQty = (stepper, q) => {
        stepper.dataset.qty = String(Math.max(0, q));
        syncStepper(stepper);
      };

      const bumpQty = (stepper, delta) => {
        if (!stepper) return;
        setQty(stepper, (parseInt(stepper.dataset.qty, 10) || 0) + delta);
        refreshTiers();
        refreshBundleState();
      };

      // The bundle is "added" only when every real bundle product has a quantity.
      const refreshBundleState = () => {
        const btns = bundleBtns();
        if (!btns.length) return;
        const real = steppers().filter((s) => s.dataset.variantId);
        const added = real.length > 0 && real.every((s) => (parseInt(s.dataset.qty, 10) || 0) > 0);
        btns.forEach((b) => b.setAttribute('aria-pressed', added ? 'true' : 'false'));
      };

      ThemeBind.delegate(root, 'click', '[data-cushions-inc]', function () {
        bumpQty(this.closest('[data-cushions-stepper]'), 1);
      });
      ThemeBind.delegate(root, 'click', '[data-cushions-dec]', function () {
        bumpQty(this.closest('[data-cushions-stepper]'), -1);
      });

      // Variant toggle on a card ("Cover" / "Cushion + Filler") → press it,
      // update the card price and point the stepper at that variant. A sold-out
      // variant can be pressed but swaps the stepper for "Sold out" and drops any
      // quantity, so nothing unavailable is ever sent to /cart/add.
      const selectCushionVariant = (card, btn) => {
        if (!card || !btn) return;
        card.querySelectorAll('[data-cushions-variant-btn]').forEach((b) => {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        const cardPrice = card.querySelector('[data-cushions-price]');
        if (cardPrice && btn.dataset.price) setText(cardPrice, btn.dataset.price);
        const available = btn.dataset.available !== 'false';
        const stepper = card.querySelector('[data-cushions-stepper]');
        if (stepper) {
          stepper.dataset.variantId = available ? btn.dataset.variantId || '' : '';
          if (btn.dataset.priceCents) stepper.dataset.priceCents = btn.dataset.priceCents;
          if (btn.dataset.compareCents) stepper.dataset.compareCents = btn.dataset.compareCents;
          if (!available) setQty(stepper, 0);
          stepper.classList.toggle('hidden', !available);
          stepper.classList.toggle('flex', available);
        }
        const soldOut = card.querySelector('[data-cushions-soldout]');
        if (soldOut) soldOut.classList.toggle('hidden', available);
      };

      ThemeBind.delegate(root, 'click', '[data-cushions-variant-btn]', function () {
        const card = this.closest('[data-cushions-card]');
        if (!card || this.getAttribute('aria-pressed') === 'true') return;
        selectCushionVariant(card, this);
        refreshTiers();
        refreshBundleState();
      });

      // Bundle card ADD → add (or toggle off) every product in the bundle at once.
      // All repeated bundle cards share one selection, so any card's button drives
      // (and reflects) the same state.
      ThemeBind.delegate(root, 'click', '[data-cushions-bundle]', function () {
        const added = this.getAttribute('aria-pressed') !== 'true';
        bundleBtns().forEach((b) => b.setAttribute('aria-pressed', added ? 'true' : 'false'));
        steppers().forEach((s) => setQty(s, added ? 1 : 0));
        refreshTiers();
      });

      // Footer "Add to basket" → replace this product's bundle lines in the cart
      // with the current selection (so re-adding never duplicates), then open the
      // drawer. Each line carries `_bundle_for: <product id>` so we can find them
      // again on return.
      ThemeBind.delegate(root, 'click', '[data-cushions-add]', async function () {
        // Stash the resting label on the button itself: a swapped-in button
        // brings its own, and a closure captured at init would restore the old
        // one over the top of it.
        const button = this;
        if (!button.dataset.restingLabel) button.dataset.restingLabel = button.textContent.trim();
        const addLabel = button.dataset.restingLabel;
        const product = productId();

        const items = [];
        steppers().forEach((s) => {
          const q = parseInt(s.dataset.qty, 10) || 0;
          const id = s.dataset.variantId;
          if (q > 0 && id) items.push({ id: Number(id), quantity: q, properties: { [BUNDLE_PROP]: String(product) } });
        });
        if (!items.length) {
          console.warn('[cushions] Add to basket: no cushion has a quantity + variant id to add.', { steppers: steppers().length });
          button.textContent = 'Select a cushion first';
          setTimeout(() => { if (button.isConnected) button.textContent = addLabel; }, 1800);
          return;
        }
        button.disabled = true;
        button.textContent = 'Adding…';
        try {
          const cartRes = await fetch(pdpCartRoute('cart_url', '/cart'), { headers: { Accept: 'application/json' } });
          if (!cartRes.ok) throw new Error('cart read failed (' + cartRes.status + ')');
          const cart = await cartRes.json();
          // what we take out, so it can be put back if the new bundle fails to add
          const removed = [];
          const updates = {};
          (cart.items || []).forEach((it) => {
            if (it.properties && String(it.properties[BUNDLE_PROP]) === String(product)) {
              updates[it.key] = 0;
              removed.push({ id: it.variant_id, quantity: it.quantity, properties: it.properties });
            }
          });
          if (Object.keys(updates).length) {
            const upd = await fetch(pdpCartRoute('cart_update_url', '/cart/update'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates }),
            });
            if (!upd.ok) throw new Error('cart update failed (' + upd.status + ')');
          }
          const res = await fetch(pdpCartRoute('cart_add_url', '/cart/add'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) {
            let detail = res.status + '';
            try { const j = await res.json(); detail = j.description || j.message || detail; } catch (e) {}
            // The old bundle was already taken out. Put it back before
            // reporting, so a failed change never leaves the basket with
            // fewer cushions than the customer had.
            if (removed.length) {
              try {
                await fetch(pdpCartRoute('cart_add_url', '/cart/add'), {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ items: removed }),
                });
              } catch (restoreErr) {}
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
            }
            throw new Error('cart add failed: ' + detail);
          }
          button.textContent = addLabel;
          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
          );
        } catch (err) {
          // Surface the failure instead of silently doing nothing.
          console.error('[cushions] Add to basket failed:', err, { items });
          button.textContent = 'Couldn’t add - try again';
          setTimeout(() => { if (button.isConnected) button.textContent = addLabel; }, 2200);
        } finally {
          button.disabled = totalQty() === 0;
        }
      });

      // Restore selection on return: if this product's bundle lines are already in
      // the cart, reflect their quantities (and chosen variants) in the steppers.
      const restoreFromCart = async () => {
        const product = productId();
        if (!product) return;
        try {
          const cart = await fetch(pdpCartRoute('cart_url', '/cart'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const qtyByVariant = {};
          (cart.items || []).forEach((it) => {
            if (it.properties && String(it.properties[BUNDLE_PROP]) === String(product)) {
              qtyByVariant[it.variant_id] = (qtyByVariant[it.variant_id] || 0) + it.quantity;
            }
          });
          if (!Object.keys(qtyByVariant).length) return;
          ThemeBind.all('[data-cushions] [data-cushions-card]', root).forEach((card) => {
            const stepper = card.querySelector('[data-cushions-stepper]');
            if (!stepper) return;
            // Match the cart line to one of the card's toggle options and press it, so
            // the price and stepper reflect the variant actually in the cart.
            const btns = Array.from(card.querySelectorAll('[data-cushions-variant-btn]'));
            const candidates = [];
            if (stepper.dataset.variantId) candidates.push(stepper.dataset.variantId);
            btns.forEach((b) => { if (b.dataset.variantId) candidates.push(b.dataset.variantId); });
            const match = candidates.find((id) => qtyByVariant[id]);
            if (!match) return;
            const btn = btns.find((b) => b.dataset.variantId === match);
            if (btn && btn.dataset.available === 'false') return; // sold out since it was added
            if (btn) selectCushionVariant(card, btn);
            else stepper.dataset.variantId = match;
            setQty(stepper, qtyByVariant[match]);
          });
          refreshTiers();
          refreshBundleState();
        } catch (err) {
          // Non-fatal - the panel just starts empty.
        }
      };

      // Bring a swapped-in panel in line with the running selection. Safe to
      // call from an observer because every write above is change-guarded.
      ThemeBind.onSwap(root, () => {
        if (!cushionsEl()) return;
        steppers().forEach(syncStepper);
        refreshTiers();
        refreshBundleState();
      });

      refreshTiers();
      restoreFromCart();
    }
  });

  // ----- Sticky details panel (desktop) -----
  // The right column locks its bottom to the bottom of the viewport as you
  // scroll past it. Pure CSS `position: sticky; bottom: 0` can't do this here:
  // the panel lives in a grid cell whose height is driven by the (taller) media
  // column, and bottom-sticky never engages while scrolling *down* a short
  // panel. So we translate the panel in flow instead - no layout shift, correct
  // width/position - clamped between its natural top and the bottom of its
  // column so it never floats above its start or spills past the section.
  (function setupPDPStickyPanel() {
    const mq = window.matchMedia('(min-width: 64rem)');
    // Cached-until-detached rather than captured once: the window listeners
    // below outlive any number of swaps, so they have to be able to find the
    // panel that is on the page now, not the one that was there at load.
    const panelEl = ThemeBind.live('[data-pdp-sticky]');
    const wrapperEl = ThemeBind.live('[data-pdp-panel]');

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    let ticking = false;
    // Cache the layout metrics that don't change while scrolling. They are only
    // re-read on layout changes (resize / ResizeObserver / breakpoint), so the
    // per-frame scroll path never touches layout-reading properties.
    let metrics = null; // { panelHeight, room, containerTop, viewportH }

    function measure() {
      const panel = panelEl();
      const wrapper = wrapperEl();
      if (!panel || !wrapper) { metrics = null; return; }
      if (!mq.matches) {
        metrics = null;
        panel.style.transform = '';
        return;
      }
      const panelHeight = panel.offsetHeight;
      metrics = {
        panelHeight: panelHeight,
        room: wrapper.offsetHeight - panelHeight, // how far the panel can travel
        containerTop: wrapper.getBoundingClientRect().top + window.scrollY, // absolute (scroll-invariant)
        viewportH: window.innerHeight,
      };
      position();
    }

    function position() {
      ticking = false;
      const panel = panelEl();
      if (!panel || !metrics) return; // mobile / not yet measured / not on page
      if (metrics.room <= 0) {
        // Panel is as tall as (or taller than) its column - nothing to scroll past.
        panel.style.transform = '';
        return;
      }
      const offset = clamp(
        window.scrollY + metrics.viewportH - metrics.panelHeight - metrics.containerTop,
        0,
        metrics.room
      );
      panel.style.transform = `translateY(${offset}px)`;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(position);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if (mq.addEventListener) mq.addEventListener('change', measure);

    // Observe whichever panel and column are current, and re-measure whenever a
    // new one appears. A ResizeObserver bound once at load was still watching
    // the detached originals after a swap, so the replacement panel never moved.
    const ro = window.ResizeObserver ? new ResizeObserver(measure) : null;
    const attach = (el) => { if (ro) ro.observe(el); measure(); };
    ThemeBind.ready('[data-pdp-sticky]', attach);
    ThemeBind.ready('[data-pdp-panel]', attach);
  })();

  // ----- Price-area review stars → scroll to the reviews section -----
  // The reviews block is a separate section, so the anchor id is generated on it
  // (data-reviews-target) and matched here at runtime - nothing is hard-coded.
  (function reviewsScrollLink() {
    const findTarget = () => document.querySelector('[data-reviews-target]');

    // Keep the anchor's href pointing at the generated id (for accessibility /
    // open-in-new-tab), re-checking in case the reviews section renders later.
    const syncHref = () => {
      const target = findTarget();
      if (!target || !target.id) return;
      document.querySelectorAll('[data-pdp-reviews-link]').forEach((a) => {
        a.setAttribute('href', '#' + target.id);
      });
    };
    // Run for the markup on the page now and again for either half arriving
    // later - a swapped-in price block brings new links with no href.
    ThemeBind.ready('[data-pdp-reviews-link]', syncHref);
    ThemeBind.ready('[data-reviews-target]', syncHref);

    ThemeBind.on('click', '[data-pdp-reviews-link]', (e) => {
      const target = findTarget();
      if (!target) return; // no reviews section on this page - leave default behaviour
      e.preventDefault();
      // Scrolling to the (always-present) target triggers a deferred section to
      // render as it enters the viewport; scroll-mt on the target offsets the
      // sticky header.
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target.id && history.replaceState) history.replaceState(null, '', '#' + target.id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-slider"] && !Shopify.designMode) return;
  try {
    
  class ProductTabSlider extends HTMLElement {
    // Looked up on use: the tab strip and its panels are re-rendered whenever
    // this block is swapped, and a captured NodeList would keep pointing at the
    // markup that was thrown away.
    get tabs() { return ThemeBind.all('[data-tab]', this); }
    get panels() { return ThemeBind.all('[data-panel]', this); }

    connectedCallback() {
      // Bound once - these listeners live on `this` and survive a plain move,
      // which also re-fires connectedCallback.
      if (this._bound) return;
      this._bound = true;
      ThemeBind.delegate(this, 'click', '[data-tab]', (e, tab) => this.activate(tab.dataset.tab));
      ThemeBind.delegate(this, 'click', '[data-slider-prev]', () => this.scroll(-1));
      ThemeBind.delegate(this, 'click', '[data-slider-next]', () => this.scroll(1));
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.dataset.panel !== id);
      });
      this.dataset.activeTab = id;
    }

    scroll(direction) {
      const panel = this.panels.find((p) => !p.classList.contains('hidden'));
      if (!panel) return;
      const scroller = panel.querySelector('[data-scroller]');
      if (!scroller) return;
      const amount = scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
  }
  customElements.define('product-tab-slider', ProductTabSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  // The size-guide drawer is opened from buttons all over the PDP - including
  // blocks a test variant replaces - so the triggers are delegated on document
  // and the drawer's own parts are resolved on use. ready() covers the drawer
  // itself arriving (or arriving again) after this script has run.
  ThemeBind.ready('size-guide', (root) => {
    const panel = () => root.querySelector('[data-size-guide]');
    const overlay = () => root.querySelector('[data-size-guide-overlay]');
    let lastFocus = null;
    let closeTimer = null;

    // The drawer lives off-screen (transform), so its images/video posters must
    // not fetch on page load. Load them the first time it opens.
    const loadDrawerMedia = () => {
      root.querySelectorAll('img[data-sg-lazy]').forEach((img) => {
        if (img.dataset.sizes) img.sizes = img.dataset.sizes;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute('data-sg-lazy');
      });
      root.querySelectorAll('[data-sg-video-poster]').forEach((wrap) => {
        const video = wrap.querySelector('video');
        if (video && !video.getAttribute('poster')) video.setAttribute('poster', wrap.dataset.sgVideoPoster);
      });
    };

    const open = (trigger) => {
      const drawer = panel();
      if (!drawer) return;
      lastFocus = trigger || document.activeElement;
      window.clearTimeout(closeTimer);
      loadDrawerMedia();
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.dataset.active = '';
        const scrim = overlay();
        if (scrim) scrim.dataset.active = '';
        drawer.focus();
      });
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      const drawer = panel();
      const scrim = overlay();
      if (drawer) delete drawer.dataset.active;
      if (scrim) delete scrim.dataset.active;
      document.documentElement.style.overflow = '';
      closeTimer = window.setTimeout(() => {
        // Re-resolve: the panel can be replaced during the transition.
        const current = panel();
        if (current) current.hidden = true;
      }, 300);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus(); } catch (e) {}
      }
    };

    // Openers sit outside this element, so they are delegated on document - and
    // registered at most once for the page, since a replacement <size-guide>
    // would otherwise re-run this callback and stack a second copy of both this
    // and the Escape handler below.
    if (!window.__sizeGuideDocumentBound) {
      window.__sizeGuideDocumentBound = true;
      ThemeBind.on('click', '[data-size-guide-open]', function (e) {
        e.preventDefault();
        // Resolved at click time so it always drives the drawer on the page now.
        const current = document.querySelector('size-guide');
        if (current && current.__sizeGuideOpen) current.__sizeGuideOpen(this);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const current = document.querySelector('size-guide');
        const drawer = current && current.querySelector('[data-size-guide]');
        if (drawer && drawer.dataset.active !== undefined && current.__sizeGuideClose) {
          current.__sizeGuideClose();
        }
      });
    }
    root.__sizeGuideOpen = open;
    root.__sizeGuideClose = close;

    ThemeBind.delegate(root, 'click', '[data-size-guide-close]', close);
    ThemeBind.delegate(root, 'click', '[data-size-guide-overlay]', close);

    ThemeBind.delegate(root, 'click', '[data-size-guide-tab]', function () {
      const target = this.getAttribute('data-size-guide-tab');
      root.querySelectorAll('[data-size-guide-tab]').forEach((t) => {
        const active = t === this;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      root.querySelectorAll('[data-size-guide-panel]').forEach((p) => {
        p.classList.toggle('hidden', p.getAttribute('data-size-guide-panel') !== target);
      });
    });

    /* Click-and-drag horizontal scrolling for the tab strip.
       Pointer state is held here rather than per-element, and every handler
       re-resolves the strip, so replacing the tab list keeps drag working. */
    {
      let down = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;
      const tablist = () => root.querySelector('[data-size-guide-tablist]');

      ThemeBind.delegate(root, 'pointerdown', '[data-size-guide-tablist]', function (e) {
        if (e.button !== 0) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startScroll = this.scrollLeft;
      });

      ThemeBind.delegate(root, 'pointermove', '[data-size-guide-tablist]', function (e) {
        if (!down) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          moved = true;
          this.dataset.dragging = '';
          this.setPointerCapture(e.pointerId);
        }
        if (moved) this.scrollLeft = startScroll - dx;
      });

      const end = () => {
        down = false;
        const strip = tablist();
        if (strip) delete strip.dataset.dragging;
      };
      ThemeBind.delegate(root, 'pointerup', '[data-size-guide-tablist]', end);
      ThemeBind.delegate(root, 'pointercancel', '[data-size-guide-tablist]', end);

      /* Swallow the click that fires after a drag so it doesn't switch tabs */
      ThemeBind.delegate(root, 'click', '[data-size-guide-tablist]', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, { capture: true });
    }

    /* Slide pagination (smaller / larger) within each panel.
       The active index lives on the panel element, so it survives the panel's
       controls being re-rendered and never needs a closure per panel. */
    const slidesIn = (p) => Array.from(p.querySelectorAll('[data-size-guide-slide]'));

    const updateSlides = (p) => {
      const slides = slidesIn(p);
      if (slides.length < 2) return;
      let idx = parseInt(p.dataset.slideIndex, 10);
      if (isNaN(idx)) {
        idx = 0;
        slides.forEach((s, i) => { if (s.hasAttribute('data-size-guide-default')) idx = i; });
        p.dataset.slideIndex = String(idx);
      }
      idx = Math.min(Math.max(idx, 0), slides.length - 1);
      slides.forEach((s, i) => s.classList.toggle('hidden', i !== idx));
      const prev = p.querySelector('[data-size-guide-prev]');
      const next = p.querySelector('[data-size-guide-next]');
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
    };

    const step = (button, delta) => {
      const p = button.closest('[data-size-guide-panel]');
      if (!p) return;
      const slides = slidesIn(p);
      const idx = Math.min(Math.max((parseInt(p.dataset.slideIndex, 10) || 0) + delta, 0), slides.length - 1);
      p.dataset.slideIndex = String(idx);
      updateSlides(p);
    };

    ThemeBind.delegate(root, 'click', '[data-size-guide-prev]', function () { step(this, -1); });
    ThemeBind.delegate(root, 'click', '[data-size-guide-next]', function () { step(this, 1); });

    const syncPanels = () => root.querySelectorAll('[data-size-guide-panel]').forEach(updateSlides);
    syncPanels();
    // Only classes and `disabled` are written above, so this cannot loop.
    ThemeBind.onSwap(root, syncPanels);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["small-card-slider"] && !Shopify.designMode) return;
  try {
    
  class SmallCardSlider extends HTMLElement {
    // Looked up on use: the tab strip and its panels are re-rendered whenever
    // this block is swapped, and a captured NodeList would keep pointing at the
    // markup that was thrown away.
    get tabs() { return ThemeBind.all('[data-tab]', this); }
    get panels() { return ThemeBind.all('[data-panel]', this); }

    connectedCallback() {
      // Bound once - these listeners live on `this` and survive a plain move,
      // which also re-fires connectedCallback.
      if (this._bound) return;
      this._bound = true;
      ThemeBind.delegate(this, 'click', '[data-tab]', (e, tab) => this.activate(tab.dataset.tab));
      ThemeBind.delegate(this, 'click', '[data-slider-prev]', () => this.scroll(-1));
      ThemeBind.delegate(this, 'click', '[data-slider-next]', () => this.scroll(1));
      // Card images are JS-lazy (data-lazy-img); the shared loader in global.js
      // swaps them in as they scroll into view.
    }


    activate(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === id;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.dataset.panel !== id);
      });
      this.dataset.activeTab = id;
    }

    scroll(direction) {
      const panel = this.panels.find((p) => !p.classList.contains('hidden'));
      if (!panel) return;
      const scroller = panel.querySelector('[data-scroller]');
      if (!scroller) return;
      const amount = scroller.clientWidth * 0.8;
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
  }
  customElements.define('small-card-slider', SmallCardSlider);

  } catch(e) { console.error(e); }
})();
})();
